
// // import React, { useCallback, useEffect, useMemo, useState } from "react";
// // import { useParams, useNavigate } from "react-router-dom";
// // import "./VillaRoomManager.css";

// // const API_BASE = (
// //   process.env.REACT_APP_API_URL || "https://bmtvendorvendorfinal.onrender.com"
// // ).replace(/\/$/, "");

// // const EMPTY_FORM = {
// //   roomName: "",
// //   roomNumber: "",
// //   roomType: "standard",
// //   description: "",
// //   bedType: "double",
// //   bedCount: 1,
// //   maxGuests: 2,
// //   maxAdults: 2,
// //   maxChildren: 0,
// //   floorNumber: "",
// //   roomSize: 0,
// //   roomSizeUnit: "sqft",
// //   totalRooms: 1,
// //   bookedRooms: 0,
// //   blockedRooms: 0,
// //   pricePerNight: "",
// //   weekendPrice: 0,
// //   extraGuestAllowed: false,
// //   extraGuestCharge: 0,
// //   amenities: [],
// //   descriptionNotes: "",
// //   isActive: true,
// // };

// // const ROOM_TYPES = [
// //   ["standard", "Standard Room"],
// //   ["deluxe", "Deluxe Room"],
// //   ["super-deluxe", "Super Deluxe"],
// //   ["premium", "Premium Room"],
// //   ["suite", "Suite"],
// //   ["master-bedroom", "Master Bedroom"],
// //   ["family-room", "Family Room"],
// //   ["private-room", "Private Room"],
// //   ["shared-room", "Shared Room"],
// //   ["other", "Other"],
// // ];

// // const AMENITIES = [
// //   "Air Conditioning",
// //   "Wi-Fi",
// //   "Television",
// //   "Attached Bathroom",
// //   "Balcony",
// //   "Mountain View",
// //   "Garden View",
// //   "Wardrobe",
// //   "Refrigerator",
// //   "Room Service",
// //   "Work Desk",
// //   "Hot Water",
// //   "Heating",
// //   "Private Entrance",
// // ];

// // const STEPS = [
// //   { title: "Room Details", subtitle: "Basic information" },
// //   { title: "Capacity & Price", subtitle: "Guests and pricing" },
// //   { title: "Photos & Amenities", subtitle: "Images and facilities" },
// //   { title: "Review & Save", subtitle: "Confirm your details" },
// // ];

// // const getToken = () => localStorage.getItem("vendorToken");

// // async function apiRequest(path, options = {}) {
// //   const token = getToken();

// //   const response = await fetch(`${API_BASE}${path}`, {
// //     ...options,
// //     headers: {
// //       ...(options.body instanceof FormData
// //         ? {}
// //         : { "Content-Type": "application/json" }),
// //       ...(token ? { Authorization: `Bearer ${token}` } : {}),
// //       ...options.headers,
// //     },
// //   });

// //   const data = await response.json().catch(() => ({}));

// //   if (!response.ok || data.success === false) {
// //     throw new Error(data.message || `Request failed (${response.status})`);
// //   }

// //   return data;
// // }

// // function money(value) {
// //   return `₹${Number(value || 0).toLocaleString("en-IN")}`;
// // }

// // function Field({ label, required, children, hint, className = "" }) {
// //   return (
// //     <div className={`vr-field ${className}`}>
// //       <label>
// //         {label} {required && <span className="vr-required">*</span>}
// //       </label>
// //       {children}
// //       {hint && <small>{hint}</small>}
// //     </div>
// //   );
// // }

// // function StepHeader({ step, setStep, readOnly }) {
// //   return (
// //     <div className="vr-stepper">
// //       {STEPS.map((item, index) => (
// //         <button
// //           type="button"
// //           key={item.title}
// //           className={`vr-step ${step === index ? "current" : ""} ${
// //             step > index ? "completed" : ""
// //           }`}
// //           onClick={() => {
// //             if (!readOnly && index < step) setStep(index);
// //           }}
// //           disabled={readOnly || index > step}
// //         >
// //           <span className="vr-step-number">
// //             {step > index ? "✓" : index + 1}
// //           </span>
// //           <span className="vr-step-copy">
// //             <strong>{item.title}</strong>
// //             <small>{item.subtitle}</small>
// //           </span>
// //         </button>
// //       ))}
// //     </div>
// //   );
// // }

// // export default function VillaRoomManager({ villaId: villaIdProp }) {
// //   const params = useParams();
// //   const navigate = useNavigate();
// //   const villaId = villaIdProp || params.villaId || params.id;

// //   const [rooms, setRooms] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [saving, setSaving] = useState(false);
// //   const [error, setError] = useState("");
// //   const [success, setSuccess] = useState("");
// //   const [search, setSearch] = useState("");
// //   const [statusFilter, setStatusFilter] = useState("all");

// //   const [page, setPage] = useState("list");
// //   const [formMode, setFormMode] = useState("create");
// //   const [step, setStep] = useState(0);
// //   const [editingId, setEditingId] = useState(null);
// //   const [form, setForm] = useState(EMPTY_FORM);

// //   const [existingImages, setExistingImages] = useState([]);
// //   const [existingCoverImage, setExistingCoverImage] = useState("");
// //   const [newImages, setNewImages] = useState([]);
// //   const [newCover, setNewCover] = useState(null);

// //   const [deleteTarget, setDeleteTarget] = useState(null);
// //   const [deleting, setDeleting] = useState(false);

// //   const readOnly = formMode === "view";

// //   const roomPath = useCallback(
// //     (suffix = "") =>
// //       `/api/vendor/villas/${encodeURIComponent(villaId)}/rooms${suffix}`,
// //     [villaId]
// //   );

// //   const loadRooms = useCallback(async () => {
// //     if (!villaId) {
// //       setError("Villa ID missing. Open room management from a specific villa.");
// //       setLoading(false);
// //       return;
// //     }

// //     setLoading(true);
// //     setError("");

// //     try {
// //       const data = await apiRequest(roomPath());
// //       setRooms(Array.isArray(data.rooms) ? data.rooms : []);
// //     } catch (err) {
// //       setError(err.message || "Unable to load rooms.");
// //     } finally {
// //       setLoading(false);
// //     }
// //   }, [roomPath, villaId]);

// //   useEffect(() => {
// //     loadRooms();
// //   }, [loadRooms]);

// //   const filteredRooms = useMemo(() => {
// //     const query = search.trim().toLowerCase();

// //     return rooms.filter((room) => {
// //       const matchesSearch =
// //         !query ||
// //         [room.roomName, room.roomNumber, room.roomType]
// //           .filter(Boolean)
// //           .some((value) => String(value).toLowerCase().includes(query));

// //       const matchesStatus =
// //         statusFilter === "all" ||
// //         (statusFilter === "active" && room.isActive) ||
// //         (statusFilter === "inactive" && !room.isActive);

// //       return matchesSearch && matchesStatus;
// //     });
// //   }, [rooms, search, statusFilter]);

// //   const resetForm = () => {
// //     setForm({ ...EMPTY_FORM });
// //     setExistingImages([]);
// //     setExistingCoverImage("");
// //     setNewImages([]);
// //     setNewCover(null);
// //     setEditingId(null);
// //     setStep(0);
// //   };

// //   const startCreate = () => {
// //     resetForm();
// //     setFormMode("create");
// //     setPage("form");
// //     setError("");
// //     setSuccess("");
// //   };

// //   const startEdit = (room) => {
// //     resetForm();

// //     setForm({
// //       ...EMPTY_FORM,
// //       ...room,
// //       villa: undefined,
// //       vendor: undefined,
// //       amenities: Array.isArray(room.amenities) ? room.amenities : [],
// //       pricePerNight: room.pricePerNight ?? "",
// //     });

// //     setEditingId(room._id);
// //     setExistingImages(Array.isArray(room.images) ? [...room.images] : []);
// //     setExistingCoverImage(room.coverImage || "");
// //     setFormMode("edit");
// //     setPage("form");
// //     setError("");
// //     setSuccess("");
// //   };

// //   const startView = async (room) => {
// //     setError("");

// //     try {
// //       const data = await apiRequest(roomPath(`/${room._id}`));
// //       const selectedRoom = data.room || room;

// //       resetForm();

// //       setForm({
// //         ...EMPTY_FORM,
// //         ...selectedRoom,
// //         amenities: Array.isArray(selectedRoom.amenities)
// //           ? selectedRoom.amenities
// //           : [],
// //       });

// //       setEditingId(selectedRoom._id);
// //       setExistingImages(
// //         Array.isArray(selectedRoom.images) ? selectedRoom.images : []
// //       );
// //       setExistingCoverImage(selectedRoom.coverImage || "");
// //       setFormMode("view");
// //       setPage("form");
// //       setStep(0);
// //     } catch (err) {
// //       setError(err.message || "Unable to load room details.");
// //     }
// //   };

// //   const setValue = (key, value) => {
// //     setForm((previous) => ({ ...previous, [key]: value }));
// //   };

// //   const handleGallerySelection = (event) => {
// //     const files = Array.from(event.target.files || []);
// //     event.target.value = "";

// //     if (!files.length) return;

// //     const validFiles = files.filter((file) => {
// //       if (!file.type.startsWith("image/")) {
// //         setError(`${file.name} is not an image.`);
// //         return false;
// //       }

// //       if (file.size > 5 * 1024 * 1024) {
// //         setError(`${file.name} is larger than 5 MB.`);
// //         return false;
// //       }

// //       return true;
// //     });

// //     setNewImages((previous) => {
// //       const combined = [...previous, ...validFiles];

// //       if (existingImages.length + combined.length > 20) {
// //         setError("Maximum 20 gallery images allowed.");
// //         return combined.slice(0, Math.max(0, 20 - existingImages.length));
// //       }

// //       return combined;
// //     });

// //     setSuccess("");
// //   };

// //   const removeExistingImage = (url) => {
// //     setExistingImages((previous) => previous.filter((item) => item !== url));

// //     if (existingCoverImage === url) {
// //       setExistingCoverImage("");
// //     }
// //   };

// //   const removeNewImage = (index) => {
// //     setNewImages((previous) => previous.filter((_, i) => i !== index));
// //   };

// //   const validateStep = (currentStep) => {
// //     if (currentStep === 0) {
// //       if (!form.roomName.trim()) return "Enter a room name.";
// //       if (!form.roomType) return "Select a room type.";
// //     }

// //     if (currentStep === 1) {
// //       if (Number(form.maxGuests) < 1) return "Maximum guests must be at least 1.";
// //       if (Number(form.maxAdults) < 1) return "Maximum adults must be at least 1.";
// //       if (Number(form.totalRooms) < 1) return "Total rooms must be at least 1.";
// //       if (Number(form.pricePerNight) < 0 || form.pricePerNight === "") {
// //         return "Enter a valid price per night.";
// //       }

// //       if (
// //         Number(form.bookedRooms) + Number(form.blockedRooms) >
// //         Number(form.totalRooms)
// //       ) {
// //         return "Booked and blocked rooms cannot exceed total rooms.";
// //       }
// //     }

// //     return "";
// //   };

// //   const nextStep = () => {
// //     const validationError = validateStep(step);

// //     if (validationError) {
// //       setError(validationError);
// //       return;
// //     }

// //     setError("");
// //     setStep((previous) => Math.min(previous + 1, STEPS.length - 1));
// //   };

// //   const previousStep = () => {
// //     setError("");
// //     setStep((previous) => Math.max(previous - 1, 0));
// //   };

// //   const handleSubmit = async (event) => {
// //     event.preventDefault();
// //     setError("");
// //     setSuccess("");

// //     if (readOnly) return;

// //     for (let index = 0; index < 2; index += 1) {
// //       const validationError = validateStep(index);

// //       if (validationError) {
// //         setStep(index);
// //         setError(validationError);
// //         return;
// //       }
// //     }

// //     const galleryCount = existingImages.length + newImages.length;

// //     if (galleryCount > 20) {
// //       setStep(2);
// //       setError("Maximum 20 gallery images allowed.");
// //       return;
// //     }

// //     setSaving(true);

// //     const body = new FormData();

// //     const fields = [
// //       "roomName",
// //       "roomNumber",
// //       "roomType",
// //       "description",
// //       "bedType",
// //       "bedCount",
// //       "maxGuests",
// //       "maxAdults",
// //       "maxChildren",
// //       "floorNumber",
// //       "roomSize",
// //       "roomSizeUnit",
// //       "totalRooms",
// //       "bookedRooms",
// //       "blockedRooms",
// //       "pricePerNight",
// //       "weekendPrice",
// //       "extraGuestAllowed",
// //       "extraGuestCharge",
// //       "descriptionNotes",
// //       "isActive",
// //     ];

// //     fields.forEach((field) => {
// //       body.append(field, String(form[field] ?? ""));
// //     });

// //     body.append("amenities", JSON.stringify(form.amenities || []));

// //     if (formMode === "edit") {
// //       body.append("existingImages", JSON.stringify(existingImages));

// //       const originalImages = rooms.find((room) => room._id === editingId);
// //       const originalUrls = originalImages?.images || [];
// //       const originalPublicIds = originalImages?.imagePublicIds || [];

// //       const retainedPublicIds = existingImages
// //         .map((url) => {
// //           const originalIndex = originalUrls.indexOf(url);
// //           return originalIndex >= 0 ? originalPublicIds[originalIndex] : null;
// //         })
// //         .filter(Boolean);

// //       body.append(
// //         "existingImagePublicIds",
// //         JSON.stringify(retainedPublicIds)
// //       );
// //       body.append("existingCoverImage", existingCoverImage || "");
// //     }

// //     if (newCover) body.append("coverImage", newCover);

// //     newImages.forEach((file) => body.append("images", file));

// //     try {
// //       if (formMode === "edit") {
// //         await apiRequest(roomPath(`/${editingId}`), {
// //           method: "PUT",
// //           body,
// //         });

// //         setSuccess("Room updated successfully.");
// //       } else {
// //         await apiRequest(roomPath(), {
// //           method: "POST",
// //           body,
// //         });

// //         setSuccess("Room created successfully.");
// //       }

// //       await loadRooms();
// //       resetForm();
// //       setPage("list");
// //     } catch (err) {
// //       setError(err.message || "Unable to save room.");
// //     } finally {
// //       setSaving(false);
// //     }
// //   };

// //   const handleDelete = async () => {
// //     if (!deleteTarget) return;

// //     setDeleting(true);
// //     setError("");

// //     try {
// //      await apiRequest(roomPath(`/${deleteTarget._id}`), {
// //   method: "DELETE",
// // });

// //       setRooms((previous) =>
// //         previous.filter((room) => room._id !== deleteTarget._id)
// //       );

// //       setDeleteTarget(null);
// //       setSuccess("Room deleted successfully.");
// //     } catch (err) {
// //       setError(err.message || "Unable to delete room.");
// //       setDeleteTarget(null);
// //     } finally {
// //       setDeleting(false);
// //     }
// //   };

// //   const toggleStatus = async (room) => {
// //     setError("");
// //     setSuccess("");

// //     try {
// //       const data = await apiRequest(
// //         roomPath(`/${room._id}/toggle-status`),
// //         { method: "PATCH" }
// //       );

// //       setRooms((previous) =>
// //         previous.map((item) =>
// //           item._id === room._id
// //             ? { ...item, ...(data.room || { isActive: !item.isActive }) }
// //             : item
// //         )
// //       );

// //       setSuccess(`Room ${room.isActive ? "deactivated" : "activated"}.`);
// //     } catch (err) {
// //       setError(err.message || "Unable to update room status.");
// //     }
// //   };

// //   const cancelForm = () => {
// //     resetForm();
// //     setPage("list");
// //     setError("");
// //   };

// //   const selectedCover =
// //     newCover
// //       ? URL.createObjectURL(newCover)
// //       : existingCoverImage || existingImages[0] || "";

// //   const activeCount = rooms.filter((room) => room.isActive).length;
// //   const totalUnits = rooms.reduce(
// //     (sum, room) => sum + Number(room.totalRooms || 0),
// //     0
// //   );

// //   if (!villaId) {
// //     return (
// //       <div className="vr-page">
// //         <div className="vr-alert error">
// //           Villa ID nahi mila. Is page ko villa ke andar se open karo.
// //         </div>
// //       </div>
// //     );
// //   }

// //   return (
// //     <div className="vr-page">
// //       <header className="vr-page-header">
// //         <div>
// //           <div className="vr-eyebrow">PROPERTY MANAGEMENT / VILLAS</div>
// //           <h1>{page === "list" ? "Villa Rooms" : formMode === "create" ? "Add New Room" : formMode === "edit" ? "Edit Room" : "Room Details"}</h1>
// //           <p>
// //             {page === "list"
// //               ? "Manage room types, photos, pricing and availability."
// //               : "Complete the steps below to manage your room information."}
// //           </p>
// //         </div>

// //         {page === "list" ? (
// //           <div className="vr-header-actions">
// //             <button className="vr-btn secondary" onClick={loadRooms} disabled={loading}>
// //               ↻ Refresh
// //             </button>
// //             <button className="vr-btn primary" onClick={startCreate}>
// //               + Add Room
// //             </button>
// //           </div>
// //         ) : (
// //           <button className="vr-btn secondary" onClick={cancelForm}>
// //             ← Back to Rooms
// //           </button>
// //         )}
// //       </header>

// //       {error && (
// //         <div className="vr-alert error" role="alert">
// //           <span>{error}</span>
// //           <button onClick={() => setError("")}>×</button>
// //         </div>
// //       )}

// //       {success && page === "list" && (
// //         <div className="vr-alert success">
// //           <span>{success}</span>
// //           <button onClick={() => setSuccess("")}>×</button>
// //         </div>
// //       )}

// //       {page === "list" ? (
// //         <>
// //           <section className="vr-stats">
// //             <div className="vr-stat">
// //               <span className="vr-stat-icon">▦</span>
// //               <div>
// //                 <small>Total room types</small>
// //                 <strong>{rooms.length}</strong>
// //               </div>
// //             </div>
// //             <div className="vr-stat">
// //               <span className="vr-stat-icon">✓</span>
// //               <div>
// //                 <small>Active room types</small>
// //                 <strong>{activeCount}</strong>
// //               </div>
// //             </div>
// //             <div className="vr-stat">
// //               <span className="vr-stat-icon">⌂</span>
// //               <div>
// //                 <small>Total room units</small>
// //                 <strong>{totalUnits}</strong>
// //               </div>
// //             </div>
// //           </section>

// //           <section className="vr-table-panel">
// //             <div className="vr-table-toolbar">
// //               <div>
// //                 <h2>Room inventory</h2>
// //                 <p>{filteredRooms.length} room type(s) found</p>
// //               </div>
// //               <div className="vr-filters">
// //                 <div className="vr-search">
// //                   <span>⌕</span>
// //                   <input
// //                     value={search}
// //                     onChange={(event) => setSearch(event.target.value)}
// //                     placeholder="Search room..."
// //                     aria-label="Search rooms"
// //                   />
// //                 </div>
// //                 <select
// //                   value={statusFilter}
// //                   onChange={(event) => setStatusFilter(event.target.value)}
// //                   aria-label="Filter room status"
// //                 >
// //                   <option value="all">All statuses</option>
// //                   <option value="active">Active</option>
// //                   <option value="inactive">Inactive</option>
// //                 </select>
// //               </div>
// //             </div>

// //             {loading ? (
// //               <div className="vr-loading">
// //                 <span className="vr-spinner" />
// //                 Loading rooms...
// //               </div>
// //             ) : filteredRooms.length === 0 ? (
// //               <div className="vr-empty">
// //                 <div className="vr-empty-icon">⌂</div>
// //                 <h3>{rooms.length ? "No matching rooms" : "No rooms added yet"}</h3>
// //                 <p>
// //                   {rooms.length
// //                     ? "Try changing the search or status filter."
// //                     : "Add the first room to start managing this villa's inventory."}
// //                 </p>
// //                 {!rooms.length && (
// //                   <button className="vr-btn primary" onClick={startCreate}>
// //                     + Create your first room
// //                   </button>
// //                 )}
// //               </div>
// //             ) : (
// //               <div className="vr-table-scroll">
// //                 <table className="vr-table">
// //                   <thead>
// //                     <tr>
// //                       <th>Room</th>
// //                       <th>Room type</th>
// //                       <th>Capacity</th>
// //                       <th>Inventory</th>
// //                       <th>Price / night</th>
// //                       <th>Status</th>
// //                       <th className="vr-action-heading">Actions</th>
// //                     </tr>
// //                   </thead>
// //                   <tbody>
// //                     {filteredRooms.map((room) => (
// //                       <tr key={room._id}>
// //                         <td>
// //                           <div className="vr-room-cell">
// //                             <div className="vr-thumb">
// //                               {(room.coverImage || room.images?.[0]) ? (
// //                                 <img
// //                                   src={room.coverImage || room.images[0]}
// //                                   alt={room.roomName}
// //                                   loading="lazy"
// //                                 />
// //                               ) : (
// //                                 <span>⌂</span>
// //                               )}
// //                             </div>
// //                             <div>
// //                               <strong>{room.roomName}</strong>
// //                               <small>
// //                                 {room.roomNumber
// //                                   ? `Room No. ${room.roomNumber}`
// //                                   : `${room.bedCount || 1} bed(s)`}
// //                               </small>
// //                             </div>
// //                           </div>
// //                         </td>
// //                         <td>
// //                           {ROOM_TYPES.find(([value]) => value === room.roomType)?.[1] ||
// //                             room.roomType ||
// //                             "Standard"}
// //                         </td>
// //                         <td>{room.maxGuests || 1} guests</td>
// //                         <td>
// //                           <strong>{room.availableRooms ?? 0}</strong>
// //                           <span className="vr-muted"> / {room.totalRooms || 0} available</span>
// //                         </td>
// //                         <td className="vr-price">{money(room.pricePerNight)}</td>
// //                         <td>
// //                           <span className={`vr-status ${room.isActive ? "active" : "inactive"}`}>
// //                             {room.isActive ? "Active" : "Inactive"}
// //                           </span>
// //                         </td>
// //                         <td>
// //                           <div className="vr-actions">
// //                             <button title="View room" onClick={() => startView(room)}>View</button>
// //                             <button title="Edit room" onClick={() => startEdit(room)}>Edit</button>
// //                             <button
// //                               title={room.isActive ? "Deactivate room" : "Activate room"}
// //                               onClick={() => toggleStatus(room)}
// //                             >
// //                               {room.isActive ? "Disable" : "Enable"}
// //                             </button>
// //                             <button
// //                               className="danger"
// //                               title="Delete room"
// //                               onClick={() => setDeleteTarget(room)}
// //                             >
// //                               Delete
// //                             </button>
// //                           </div>
// //                         </td>
// //                       </tr>
// //                     ))}
// //                   </tbody>
// //                 </table>
// //               </div>
// //             )}
// //           </section>
// //         </>
// //       ) : (
// //         <form className="vr-form-layout" onSubmit={handleSubmit}>
// //           <StepHeader step={step} setStep={setStep} readOnly={readOnly} />

// //           <section className="vr-form-panel">
// //             <div className="vr-form-heading">
// //               <div>
// //                 <span className="vr-form-step-label">STEP {step + 1} OF {STEPS.length}</span>
// //                 <h2>{STEPS[step].title}</h2>
// //                 <p>{STEPS[step].subtitle}</p>
// //               </div>
// //               {readOnly && <span className="vr-status active">View only</span>}
// //             </div>

// //             {step === 0 && (
// //               <div className="vr-form-grid">
// //                 <Field label="Room name" required>
// //                   <input
// //                     value={form.roomName}
// //                     onChange={(e) => setValue("roomName", e.target.value)}
// //                     placeholder="e.g. Deluxe Garden Room"
// //                     required
// //                     disabled={readOnly}
// //                   />
// //                 </Field>

// //                 <Field label="Room number / identifier">
// //                   <input
// //                     value={form.roomNumber || ""}
// //                     onChange={(e) => setValue("roomNumber", e.target.value)}
// //                     placeholder="e.g. R-101"
// //                     disabled={readOnly}
// //                   />
// //                 </Field>

// //                 <Field label="Room type" required>
// //                   <select
// //                     value={form.roomType}
// //                     onChange={(e) => setValue("roomType", e.target.value)}
// //                     disabled={readOnly}
// //                   >
// //                     {ROOM_TYPES.map(([value, label]) => (
// //                       <option key={value} value={value}>{label}</option>
// //                     ))}
// //                   </select>
// //                 </Field>

// //                 <Field label="Floor">
// //                   <input
// //                     value={form.floorNumber || ""}
// //                     onChange={(e) => setValue("floorNumber", e.target.value)}
// //                     placeholder="e.g. Ground floor"
// //                     disabled={readOnly}
// //                   />
// //                 </Field>

// //                 <Field label="Room description" className="full">
// //                   <textarea
// //                     rows="4"
// //                     value={form.description || ""}
// //                     onChange={(e) => setValue("description", e.target.value)}
// //                     placeholder="Describe the room, view and important details..."
// //                     disabled={readOnly}
// //                   />
// //                 </Field>

// //                 <Field label="Room size">
// //                   <div className="vr-inline-input">
// //                     <input
// //                       type="number"
// //                       min="0"
// //                       value={form.roomSize ?? 0}
// //                       onChange={(e) => setValue("roomSize", e.target.value)}
// //                       disabled={readOnly}
// //                     />
// //                     <select
// //                       value={form.roomSizeUnit || "sqft"}
// //                       onChange={(e) => setValue("roomSizeUnit", e.target.value)}
// //                       disabled={readOnly}
// //                     >
// //                       <option value="sqft">sq ft</option>
// //                       <option value="sqm">sq m</option>
// //                     </select>
// //                   </div>
// //                 </Field>
// //               </div>
// //             )}

// //             {step === 1 && (
// //               <div className="vr-form-grid">
// //                 <Field label="Bed type" required>
// //                   <select
// //                     value={form.bedType || "double"}
// //                     onChange={(e) => setValue("bedType", e.target.value)}
// //                     disabled={readOnly}
// //                   >
// //                     {["single", "twin", "double", "queen", "king", "bunk", "multiple", "other"].map((value) => (
// //                       <option value={value} key={value}>
// //                         {value.charAt(0).toUpperCase() + value.slice(1)}
// //                       </option>
// //                     ))}
// //                   </select>
// //                 </Field>

// //                 <Field label="Number of beds" required>
// //                   <input
// //                     type="number"
// //                     min="1"
// //                     value={form.bedCount ?? 1}
// //                     onChange={(e) => setValue("bedCount", e.target.value)}
// //                     disabled={readOnly}
// //                   />
// //                 </Field>

// //                 <Field label="Maximum guests" required>
// //                   <input
// //                     type="number"
// //                     min="1"
// //                     value={form.maxGuests}
// //                     onChange={(e) => setValue("maxGuests", e.target.value)}
// //                     disabled={readOnly}
// //                   />
// //                 </Field>

// //                 <Field label="Maximum adults" required>
// //                   <input
// //                     type="number"
// //                     min="1"
// //                     value={form.maxAdults}
// //                     onChange={(e) => setValue("maxAdults", e.target.value)}
// //                     disabled={readOnly}
// //                   />
// //                 </Field>

// //                 <Field label="Maximum children">
// //                   <input
// //                     type="number"
// //                     min="0"
// //                     value={form.maxChildren}
// //                     onChange={(e) => setValue("maxChildren", e.target.value)}
// //                     disabled={readOnly}
// //                   />
// //                 </Field>

// //                 <Field label="Total rooms / units" required>
// //                   <input
// //                     type="number"
// //                     min="1"
// //                     value={form.totalRooms}
// //                     onChange={(e) => setValue("totalRooms", e.target.value)}
// //                     disabled={readOnly}
// //                   />
// //                 </Field>

// //                 <Field label="Already booked">
// //                   <input
// //                     type="number"
// //                     min="0"
// //                     value={form.bookedRooms}
// //                     onChange={(e) => setValue("bookedRooms", e.target.value)}
// //                     disabled={readOnly}
// //                   />
// //                 </Field>

// //                 <Field label="Blocked rooms">
// //                   <input
// //                     type="number"
// //                     min="0"
// //                     value={form.blockedRooms}
// //                     onChange={(e) => setValue("blockedRooms", e.target.value)}
// //                     disabled={readOnly}
// //                   />
// //                 </Field>

// //                 <div className="vr-availability-note full">
// //                   <strong>Available rooms</strong>
// //                   <span>
// //                     {Math.max(
// //                       0,
// //                       Number(form.totalRooms || 0) -
// //                         Number(form.bookedRooms || 0) -
// //                         Number(form.blockedRooms || 0)
// //                     )}{" "}
// //                     units available
// //                   </span>
// //                 </div>

// //                 <Field label="Price per night (₹)" required>
// //                   <input
// //                     type="number"
// //                     min="0"
// //                     value={form.pricePerNight}
// //                     onChange={(e) => setValue("pricePerNight", e.target.value)}
// //                     placeholder="e.g. 2500"
// //                     required
// //                     disabled={readOnly}
// //                   />
// //                 </Field>

// //                 <Field label="Weekend price (₹)">
// //                   <input
// //                     type="number"
// //                     min="0"
// //                     value={form.weekendPrice ?? 0}
// //                     onChange={(e) => setValue("weekendPrice", e.target.value)}
// //                     disabled={readOnly}
// //                   />
// //                 </Field>

// //                 <div className="vr-checkbox-row full">
// //                   <label className="vr-check-label">
// //                     <input
// //                       type="checkbox"
// //                       checked={Boolean(form.extraGuestAllowed)}
// //                       onChange={(e) => setValue("extraGuestAllowed", e.target.checked)}
// //                       disabled={readOnly}
// //                     />
// //                     Allow extra guests
// //                   </label>
// //                 </div>

// //                 {form.extraGuestAllowed && (
// //                   <Field label="Extra guest charge (₹)">
// //                     <input
// //                       type="number"
// //                       min="0"
// //                       value={form.extraGuestCharge ?? 0}
// //                       onChange={(e) => setValue("extraGuestCharge", e.target.value)}
// //                       disabled={readOnly}
// //                     />
// //                   </Field>
// //                 )}
// //               </div>
// //             )}

// //             {step === 2 && (
// //               <div className="vr-image-section">
// //                 <div className="vr-image-intro">
// //                   <h3>Room photos</h3>
// //                   <p>Use clear, well-lit photos. JPG, PNG, WEBP or AVIF; maximum 5 MB per image.</p>
// //                 </div>

// //                 <div className="vr-cover-upload">
// //                   <div className="vr-cover-preview">
// //                     {selectedCover ? (
// //                       <img src={selectedCover} alt="Room cover preview" />
// //                     ) : (
// //                       <div className="vr-image-placeholder">
// //                         <span>▧</span>
// //                         <strong>No cover image</strong>
// //                         <small>Upload a main room photo</small>
// //                       </div>
// //                     )}
// //                   </div>

// //                   {!readOnly && (
// //                     <div className="vr-cover-controls">
// //                       <strong>Cover image</strong>
// //                       <p>This photo represents the room in the inventory table.</p>
// //                       <label className="vr-btn secondary file-button">
// //                         Choose cover image
// //                         <input
// //                           type="file"
// //                           accept="image/jpeg,image/png,image/webp,image/avif"
// //                           onChange={(e) => {
// //                             const file = e.target.files?.[0];
// //                             e.target.value = "";
// //                             if (!file) return;

// //                             if (file.size > 5 * 1024 * 1024) {
// //                               setError("Cover image must be 5 MB or smaller.");
// //                               return;
// //                             }

// //                             setNewCover(file);
// //                             setError("");
// //                           }}
// //                         />
// //                       </label>
// //                       {newCover && (
// //                         <button
// //                           type="button"
// //                           className="vr-text-button"
// //                           onClick={() => setNewCover(null)}
// //                         >
// //                           Keep existing cover
// //                         </button>
// //                       )}
// //                     </div>
// //                   )}
// //                 </div>

// //                 <div className="vr-gallery-heading">
// //                   <div>
// //                     <h3>Gallery images</h3>
// //                     <p>{existingImages.length + newImages.length} of 20 images</p>
// //                   </div>
// //                   {!readOnly && (
// //                     <label className="vr-btn secondary file-button">
// //                       + Add images
// //                       <input
// //                         type="file"
// //                         accept="image/jpeg,image/png,image/webp,image/avif"
// //                         multiple
// //                         onChange={handleGallerySelection}
// //                       />
// //                     </label>
// //                   )}
// //                 </div>

// //                 <div className="vr-gallery-grid">
// //                   {existingImages.map((url, index) => (
// //                     <div className="vr-gallery-image" key={url}>
// //                       <img src={url} alt={`Room gallery ${index + 1}`} />
// //                       <span className="vr-image-tag">Saved</span>
// //                       {!readOnly && (
// //                         <button
// //                           type="button"
// //                           className="vr-image-remove"
// //                           title="Remove image"
// //                           onClick={() => removeExistingImage(url)}
// //                         >
// //                           ×
// //                         </button>
// //                       )}
// //                     </div>
// //                   ))}

// //                   {newImages.map((file, index) => (
// //                     <div className="vr-gallery-image" key={`${file.name}-${index}`}>
// //                       <img src={URL.createObjectURL(file)} alt={file.name} />
// //                       <span className="vr-image-tag new">New</span>
// //                       {!readOnly && (
// //                         <button
// //                           type="button"
// //                           className="vr-image-remove"
// //                           title="Remove image"
// //                           onClick={() => removeNewImage(index)}
// //                         >
// //                           ×
// //                         </button>
// //                       )}
// //                     </div>
// //                   ))}
// //                 </div>

// //                 {!existingImages.length && !newImages.length && (
// //                   <div className="vr-gallery-empty">
// //                     Gallery images will appear here after you select them.
// //                   </div>
// //                 )}

// //                 <div className="vr-amenities-section">
// //                   <h3>Room amenities</h3>
// //                   <p>Select all facilities available in this room.</p>
// //                   <div className="vr-amenities-grid">
// //                     {AMENITIES.map((amenity) => (
// //                       <label className="vr-amenity" key={amenity}>
// //                         <input
// //                           type="checkbox"
// //                           checked={form.amenities.includes(amenity)}
// //                           onChange={(e) => {
// //                             if (e.target.checked) {
// //                               setValue("amenities", [...form.amenities, amenity]);
// //                             } else {
// //                               setValue(
// //                                 "amenities",
// //                                 form.amenities.filter((item) => item !== amenity)
// //                               );
// //                             }
// //                           }}
// //                           disabled={readOnly}
// //                         />
// //                         <span>{amenity}</span>
// //                       </label>
// //                     ))}
// //                   </div>
// //                 </div>

// //                 <Field label="Internal notes" className="full">
// //                   <textarea
// //                     rows="3"
// //                     value={form.descriptionNotes || ""}
// //                     onChange={(e) => setValue("descriptionNotes", e.target.value)}
// //                     placeholder="Optional notes for your team..."
// //                     disabled={readOnly}
// //                   />
// //                 </Field>
// //               </div>
// //             )}

// //             {step === 3 && (
// //               <div className="vr-review">
// //                 <div className="vr-review-banner">
// //                   <div className="vr-review-cover">
// //                     {selectedCover ? (
// //                       <img src={selectedCover} alt="Room cover" />
// //                     ) : (
// //                       <span>⌂</span>
// //                     )}
// //                   </div>
// //                   <div>
// //                     <span className="vr-review-label">ROOM SUMMARY</span>
// //                     <h3>{form.roomName || "Untitled room"}</h3>
// //                     <p>
// //                       {ROOM_TYPES.find(([value]) => value === form.roomType)?.[1] ||
// //                         form.roomType}
// //                       {form.roomNumber ? ` · Room ${form.roomNumber}` : ""}
// //                     </p>
// //                     <strong className="vr-review-price">
// //                       {money(form.pricePerNight)} <small>/ night</small>
// //                     </strong>
// //                   </div>
// //                 </div>

// //                 <div className="vr-review-grid">
// //                   <div><small>Max guests</small><strong>{form.maxGuests}</strong></div>
// //                   <div><small>Beds</small><strong>{form.bedCount} · {form.bedType}</strong></div>
// //                   <div><small>Total rooms</small><strong>{form.totalRooms}</strong></div>
// //                   <div><small>Available</small><strong>{Math.max(0, Number(form.totalRooms || 0) - Number(form.bookedRooms || 0) - Number(form.blockedRooms || 0))}</strong></div>
// //                   <div><small>Weekend price</small><strong>{money(form.weekendPrice)}</strong></div>
// //                   <div><small>Photos</small><strong>{existingImages.length + newImages.length + (newCover ? 1 : 0)}</strong></div>
// //                 </div>

// //                 <div className="vr-review-block">
// //                   <h4>Description</h4>
// //                   <p>{form.description || "No description provided."}</p>
// //                 </div>

// //                 <div className="vr-review-block">
// //                   <h4>Amenities</h4>
// //                   <div className="vr-review-tags">
// //                     {form.amenities.length
// //                       ? form.amenities.map((amenity) => <span key={amenity}>{amenity}</span>)
// //                       : <small>No amenities selected.</small>}
// //                   </div>
// //                 </div>

// //                 {!readOnly && (
// //                   <label className="vr-check-label vr-final-active">
// //                     <input
// //                       type="checkbox"
// //                       checked={Boolean(form.isActive)}
// //                       onChange={(e) => setValue("isActive", e.target.checked)}
// //                     />
// //                     Make this room active
// //                   </label>
// //                 )}
// //               </div>
// //             )}

// //             <div className="vr-form-footer">
// //               <div className="vr-footer-left">
// //                 <span>Step {step + 1} of {STEPS.length}</span>
// //                 <div className="vr-progress-track">
// //                   <div style={{ width: `${((step + 1) / STEPS.length) * 100}%` }} />
// //                 </div>
// //               </div>

// //               <div className="vr-footer-actions">
// //                 {step > 0 && (
// //                   <button
// //                     type="button"
// //                     className="vr-btn secondary"
// //                     onClick={previousStep}
// //                   >
// //                     ← Previous
// //                   </button>
// //                 )}

// //                 {step < STEPS.length - 1 ? (
// //                   <button
// //                     type="button"
// //                     className="vr-btn primary"
// //                     onClick={nextStep}
// //                   >
// //                     Continue →
// //                   </button>
// //                 ) : readOnly ? (
// //                   <button
// //                     type="button"
// //                     className="vr-btn primary"
// //                     onClick={() => startEdit(rooms.find((room) => room._id === editingId) || form)}
// //                   >
// //                     Edit Room
// //                   </button>
// //                 ) : (
// //                   <button
// //                     type="submit"
// //                     className="vr-btn primary"
// //                     disabled={saving}
// //                   >
// //                     {saving ? "Saving..." : formMode === "edit" ? "Save Changes" : "Create Room"}
// //                   </button>
// //                 )}
// //               </div>
// //             </div>
// //           </section>
// //         </form>
// //       )}

// //       {deleteTarget && (
// //         <div className="vr-confirm-overlay" role="presentation">
// //           <section className="vr-confirm-panel" role="alertdialog" aria-modal="true" aria-labelledby="vr-delete-title">
// //             <div className="vr-confirm-icon">!</div>
// //             <h2 id="vr-delete-title">Delete this room?</h2>
// //             <p>
// //               You are about to delete <strong>{deleteTarget.roomName}</strong>.
// //               This action cannot be undone.
// //             </p>
// //             <div className="vr-confirm-actions">
// //               <button
// //                 className="vr-btn secondary"
// //                 onClick={() => setDeleteTarget(null)}
// //                 disabled={deleting}
// //               >
// //                 Cancel
// //               </button>
// //               <button
// //                 className="vr-btn danger-button"
// //                 onClick={handleDelete}
// //                 disabled={deleting}
// //               >
// //                 {deleting ? "Deleting..." : "Delete Room"}
// //               </button>
// //             </div>
// //           </section>
// //         </div>
// //       )}
// //     </div>
// //   );
// // }



// import React, { useCallback, useEffect, useMemo, useState } from "react";
// import "./VillaRoomManager.css";

// const API_BASE = (
//   process.env.REACT_APP_API_URL || "https://bmtvendorvendorfinal.onrender.com"
// ).replace(/\/$/, "");

// const VILLA_KEY = "bmtVillaRoomSelectedVilla";
// const MAX_GALLERY = 20;
// const MAX_MB = 5;

// const EMPTY_FORM = {
//   roomName: "",
//   roomNumber: "",
//   roomType: "standard",
//   description: "",
//   bedType: "double",
//   bedCount: "1",
//   maxGuests: "2",
//   maxAdults: "2",
//   maxChildren: "0",
//   floorNumber: "",
//   roomSize: "0",
//   roomSizeUnit: "sqft",
//   totalRooms: "1",
//   bookedRooms: "0",
//   blockedRooms: "0",
//   pricePerNight: "",
//   weekendPrice: "0",
//   extraGuestAllowed: false,
//   extraGuestCharge: "0",
//   amenities: [],
//   descriptionNotes: "",
//   isActive: true,
// };

// const TEXT_FIELDS = [
//   "roomName", "roomNumber", "roomType", "description", "bedType",
//   "floorNumber", "roomSizeUnit", "descriptionNotes",
// ];

// const NUM_FIELDS = [
//   "bedCount", "maxGuests", "maxAdults", "maxChildren", "roomSize",
//   "totalRooms", "bookedRooms", "blockedRooms", "pricePerNight",
//   "weekendPrice", "extraGuestCharge",
// ];

// const ROOM_TYPES = [
//   ["standard", "Standard Room"],
//   ["deluxe", "Deluxe Room"],
//   ["super-deluxe", "Super Deluxe"],
//   ["premium", "Premium Room"],
//   ["suite", "Suite"],
//   ["master-bedroom", "Master Bedroom"],
//   ["family-room", "Family Room"],
//   ["private-room", "Private Room"],
//   ["shared-room", "Shared Room"],
//   ["other", "Other"],
// ];

// const BED_TYPES = ["single", "twin", "double", "queen", "king", "bunk", "multiple", "other"];

// const AMENITIES = [
//   "Air Conditioning", "Wi-Fi", "Television", "Attached Bathroom", "Balcony",
//   "Mountain View", "Garden View", "Wardrobe", "Refrigerator", "Room Service",
//   "Work Desk", "Hot Water", "Heating", "Private Entrance",
// ];

// const STEPS = [
//   { title: "Room details", subtitle: "Basic information" },
//   { title: "Capacity & price", subtitle: "Guests, inventory, pricing" },
//   { title: "Photos & amenities", subtitle: "Images and facilities" },
//   { title: "Review & save", subtitle: "Confirm your details" },
// ];

// const typeLabel = (v) => ROOM_TYPES.find(([k]) => k === v)?.[1] || v || "Standard";
// const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : "");
// const money = (v) => `₹${Number(v || 0).toLocaleString("en-IN")}`;
// const availableOf = (f) =>
//   Math.max(0, Number(f.totalRooms || 0) - Number(f.bookedRooms || 0) - Number(f.blockedRooms || 0));

// const formFromRoom = (room) => {
//   const next = { ...EMPTY_FORM };
//   Object.keys(EMPTY_FORM).forEach((key) => {
//     if (room[key] !== undefined && room[key] !== null) next[key] = room[key];
//   });
//   NUM_FIELDS.forEach((key) => (next[key] = String(next[key] ?? "")));
//   next.amenities = Array.isArray(room.amenities) ? [...room.amenities] : [];
//   return next;
// };

// async function apiRequest(path, options = {}) {
//   const token = localStorage.getItem("vendorToken");

//   const response = await fetch(`${API_BASE}${path}`, {
//     ...options,
//     headers: {
//       ...(options.body instanceof FormData ? {} : { "Content-Type": "application/json" }),
//       ...(token ? { Authorization: `Bearer ${token}` } : {}),
//       ...options.headers,
//     },
//   });

//   const data = await response.json().catch(() => ({}));

//   if (!response.ok || data.success === false) {
//     throw new Error(
//       data.message ||
//         (response.status === 401
//           ? "Session expired. Please log in again."
//           : `Request failed (${response.status})`)
//     );
//   }
//   return data;
// }

// /* ---------- small shared pieces ---------- */

// function Field({ label, required, hint, full, children }) {
//   return (
//     <div className={`vr-field ${full ? "full" : ""}`}>
//       <label>
//         {label} {required && <span className="vr-required">*</span>}
//       </label>
//       {children}
//       {hint && <small>{hint}</small>}
//     </div>
//   );
// }

// function useModalBehaviour(onClose, locked) {
//   useEffect(() => {
//     const previous = document.body.style.overflow;
//     document.body.style.overflow = "hidden";
//     const onKey = (e) => {
//       if (e.key === "Escape" && !locked) onClose();
//     };
//     window.addEventListener("keydown", onKey);
//     return () => {
//       document.body.style.overflow = previous;
//       window.removeEventListener("keydown", onKey);
//     };
//   }, [onClose, locked]);
// }

// /* ---------- ADD / EDIT MODAL ---------- */

// function RoomFormModal({ mode, room, roomPath, onClose, onSaved }) {
//   const isEdit = mode === "edit";

//   const [step, setStep] = useState(0);
//   const [form, setForm] = useState(() => (room ? formFromRoom(room) : { ...EMPTY_FORM }));
//   const [existingImages, setExistingImages] = useState(() => (room?.images ? [...room.images] : []));
//   const [existingCover, setExistingCover] = useState(room?.coverImage || "");
//   const [newImages, setNewImages] = useState([]);
//   const [newCover, setNewCover] = useState(null);
//   const [error, setError] = useState("");
//   const [saving, setSaving] = useState(false);

//   useModalBehaviour(onClose, saving);

//   const galleryPreviews = useMemo(
//     () => newImages.map((file) => ({ file, url: URL.createObjectURL(file) })),
//     [newImages]
//   );
//   useEffect(
//     () => () => galleryPreviews.forEach((p) => URL.revokeObjectURL(p.url)),
//     [galleryPreviews]
//   );

//   const coverPreview = useMemo(
//     () => (newCover ? URL.createObjectURL(newCover) : ""),
//     [newCover]
//   );
//   useEffect(
//     () => () => {
//       if (coverPreview) URL.revokeObjectURL(coverPreview);
//     },
//     [coverPreview]
//   );

//   const shownCover = coverPreview || existingCover || existingImages[0] || "";
//   const totalGallery = existingImages.length + newImages.length;

//   const setValue = (key, value) => setForm((p) => ({ ...p, [key]: value }));
//   const bind = (key) => ({
//     value: form[key] ?? "",
//     onChange: (e) => setValue(key, e.target.value),
//   });

//   const toggleAmenity = (name) =>
//     setForm((p) => ({
//       ...p,
//       amenities: p.amenities.includes(name)
//         ? p.amenities.filter((a) => a !== name)
//         : [...p.amenities, name],
//     }));

//   const validate = (index) => {
//     if (index === 0) {
//       if (!form.roomName.trim()) return "Please enter a room name.";
//     }
//     if (index === 1) {
//       const n = (k) => Number(form[k]);
//       if (!(n("bedCount") >= 1)) return "Number of beds must be at least 1.";
//       if (!(n("maxGuests") >= 1)) return "Maximum guests must be at least 1.";
//       if (!(n("maxAdults") >= 1)) return "Maximum adults must be at least 1.";
//       if (!(n("maxChildren") >= 0)) return "Maximum children cannot be negative.";
//       if (!Number.isInteger(n("totalRooms")) || n("totalRooms") < 1)
//         return "Total rooms must be a whole number of at least 1.";
//       if (!Number.isInteger(n("bookedRooms")) || n("bookedRooms") < 0)
//         return "Booked rooms must be a whole number (0 or more).";
//       if (!Number.isInteger(n("blockedRooms")) || n("blockedRooms") < 0)
//         return "Blocked rooms must be a whole number (0 or more).";
//       if (n("bookedRooms") + n("blockedRooms") > n("totalRooms"))
//         return "Booked and blocked rooms cannot exceed total rooms.";
//       if (form.pricePerNight === "" || !(n("pricePerNight") >= 0))
//         return "Please enter a valid price per night.";
//       if (!(n("weekendPrice") >= 0)) return "Weekend price cannot be negative.";
//     }
//     if (index === 2) {
//       if (!shownCover && totalGallery === 0) return "Please add at least one room photo.";
//       if (totalGallery > MAX_GALLERY) return `Maximum ${MAX_GALLERY} gallery images allowed.`;
//     }
//     return "";
//   };

//   const goNext = () => {
//     const message = validate(step);
//     if (message) return setError(message);
//     setError("");
//     setStep((s) => Math.min(s + 1, STEPS.length - 1));
//   };

//   const goBack = () => {
//     setError("");
//     setStep((s) => Math.max(s - 1, 0));
//   };

//   const pickFiles = (event, onlyFirst) => {
//     const files = Array.from(event.target.files || []);
//     event.target.value = "";
//     if (!files.length) return [];

//     const ok = [];
//     for (const file of files) {
//       if (!file.type.startsWith("image/")) {
//         setError(`${file.name} is not an image.`);
//         continue;
//       }
//       if (file.size > MAX_MB * 1024 * 1024) {
//         setError(`${file.name} is larger than ${MAX_MB} MB.`);
//         continue;
//       }
//       ok.push(file);
//     }
//     return onlyFirst ? ok.slice(0, 1) : ok;
//   };

//   const onGalleryPick = (event) => {
//     const ok = pickFiles(event, false);
//     if (!ok.length) return;
//     const room_left = MAX_GALLERY - totalGallery;
//     if (ok.length > room_left) setError(`Only ${MAX_GALLERY} gallery images are allowed in total.`);
//     else setError("");
//     setNewImages((p) => [...p, ...ok.slice(0, Math.max(room_left, 0))]);
//   };

//   const onCoverPick = (event) => {
//     const [file] = pickFiles(event, true);
//     if (!file) return;
//     setNewCover(file);
//     setError("");
//   };

//   const removeExisting = (url) => {
//     setExistingImages((p) => p.filter((u) => u !== url));
//     if (existingCover === url) setExistingCover("");
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     if (step !== STEPS.length - 1) return;

//     for (let i = 0; i < STEPS.length - 1; i += 1) {
//       const message = validate(i);
//       if (message) {
//         setStep(i);
//         setError(message);
//         return;
//       }
//     }

//     setSaving(true);
//     setError("");

//     try {
//       const body = new FormData();

//       TEXT_FIELDS.forEach((f) => body.append(f, String(form[f] ?? "").trim()));
//       NUM_FIELDS.forEach((f) => body.append(f, String(Number(form[f]) || 0)));
//       body.append("extraGuestAllowed", String(Boolean(form.extraGuestAllowed)));
//       body.append("isActive", String(Boolean(form.isActive)));
//       body.append("amenities", JSON.stringify(form.amenities));

//       if (isEdit) {
//         const originalUrls = room?.images || [];
//         const originalIds = room?.imagePublicIds || [];
//         const keptIds = existingImages
//           .map((url) => originalIds[originalUrls.indexOf(url)])
//           .filter(Boolean);

//         body.append("existingImages", JSON.stringify(existingImages));
//         body.append("existingImagePublicIds", JSON.stringify(keptIds));
//         body.append("existingCoverImage", existingCover || "");
//       }

//       if (newCover) body.append("coverImage", newCover);
//       newImages.forEach((file) => body.append("images", file));

//       const data = await apiRequest(isEdit ? roomPath(`/${room._id}`) : roomPath(), {
//         method: isEdit ? "PUT" : "POST",
//         body,
//       });

//       onSaved(data.room, mode);
//     } catch (err) {
//       setError(err.message || "Unable to save room.");
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <div className="vr-overlay" onMouseDown={(e) => e.target === e.currentTarget && !saving && onClose()}>
//       <form
//         className="vr-modal"
//         onSubmit={handleSubmit}
//         onKeyDown={(e) => {
//           if (e.key === "Enter" && e.target.tagName === "INPUT" && e.target.type !== "file")
//             e.preventDefault();
//         }}
//         role="dialog"
//         aria-modal="true"
//         aria-labelledby="vr-form-title"
//       >
//         <header className="vr-modal-head">
//           <div>
//             <span className="vr-kicker">{isEdit ? "EDIT ROOM" : "NEW ROOM"}</span>
//             <h2 id="vr-form-title">
//               {isEdit ? `Edit “${room?.roomName || "room"}”` : "Add a new room"}
//             </h2>
//           </div>
//           <button type="button" className="vr-icon-btn" onClick={onClose} disabled={saving} aria-label="Close">
//             ×
//           </button>
//         </header>

//         <div className="vr-stepper">
//           {STEPS.map((item, index) => (
//             <button
//               type="button"
//               key={item.title}
//               className={`vr-step ${index === step ? "current" : ""} ${index < step ? "done" : ""}`}
//               onClick={() => {
//                 if (isEdit || index < step) {
//                   setStep(index);
//                   setError("");
//                 }
//               }}
//             >
//               <span className="vr-step-no">{index < step ? "✓" : index + 1}</span>
//               <span className="vr-step-text">
//                 <strong>{item.title}</strong>
//                 <small>{item.subtitle}</small>
//               </span>
//             </button>
//           ))}
//         </div>

//         <div className="vr-progress"><div style={{ width: `${((step + 1) / STEPS.length) * 100}%` }} /></div>

//         <div className="vr-modal-body">
//           {error && (
//             <div className="vr-alert error" role="alert">
//               <span>{error}</span>
//               <button type="button" onClick={() => setError("")}>×</button>
//             </div>
//           )}

//           {step === 0 && (
//             <div className="vr-grid">
//               <Field label="Room name" required>
//                 <input {...bind("roomName")} placeholder="e.g. Deluxe Garden Room" maxLength={120} autoFocus />
//               </Field>
//               <Field label="Room number / identifier">
//                 <input {...bind("roomNumber")} placeholder="e.g. R-101" />
//               </Field>
//               <Field label="Room type" required>
//                 <select {...bind("roomType")}>
//                   {ROOM_TYPES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
//                 </select>
//               </Field>
//               <Field label="Floor">
//                 <input {...bind("floorNumber")} placeholder="e.g. Ground floor" />
//               </Field>
//               <Field label="Room size">
//                 <div className="vr-inline">
//                   <input type="number" min="0" {...bind("roomSize")} />
//                   <select {...bind("roomSizeUnit")}>
//                     <option value="sqft">sq ft</option>
//                     <option value="sqm">sq m</option>
//                   </select>
//                 </div>
//               </Field>
//               <div />
//               <Field label="Description" full>
//                 <textarea rows="4" {...bind("description")} placeholder="Describe the room, view and important details..." />
//               </Field>
//             </div>
//           )}

//           {step === 1 && (
//             <>
//               <h3 className="vr-sub">Beds & guests</h3>
//               <div className="vr-grid three">
//                 <Field label="Bed type" required>
//                   <select {...bind("bedType")}>
//                     {BED_TYPES.map((v) => <option key={v} value={v}>{cap(v)}</option>)}
//                   </select>
//                 </Field>
//                 <Field label="Number of beds" required>
//                   <input type="number" min="1" {...bind("bedCount")} />
//                 </Field>
//                 <Field label="Maximum guests" required>
//                   <input type="number" min="1" {...bind("maxGuests")} />
//                 </Field>
//                 <Field label="Maximum adults" required>
//                   <input type="number" min="1" {...bind("maxAdults")} />
//                 </Field>
//                 <Field label="Maximum children">
//                   <input type="number" min="0" {...bind("maxChildren")} />
//                 </Field>
//               </div>

//               <h3 className="vr-sub">Inventory</h3>
//               <div className="vr-grid three">
//                 <Field label="Total rooms / units" required>
//                   <input type="number" min="1" {...bind("totalRooms")} />
//                 </Field>
//                 <Field label="Already booked">
//                   <input type="number" min="0" {...bind("bookedRooms")} />
//                 </Field>
//                 <Field label="Blocked rooms">
//                   <input type="number" min="0" {...bind("blockedRooms")} />
//                 </Field>
//               </div>
//               <div className="vr-note">
//                 <strong>Available units</strong>
//                 <span>{availableOf(form)} of {Number(form.totalRooms || 0)}</span>
//               </div>

//               <h3 className="vr-sub">Pricing</h3>
//               <div className="vr-grid three">
//                 <Field label="Price per night (₹)" required>
//                   <input type="number" min="0" {...bind("pricePerNight")} placeholder="e.g. 2500" />
//                 </Field>
//                 <Field label="Weekend price (₹)">
//                   <input type="number" min="0" {...bind("weekendPrice")} />
//                 </Field>
//                 <Field label="Extra guest charge (₹)">
//                   <input
//                     type="number"
//                     min="0"
//                     {...bind("extraGuestCharge")}
//                     disabled={!form.extraGuestAllowed}
//                   />
//                 </Field>
//               </div>
//               <label className="vr-check">
//                 <input
//                   type="checkbox"
//                   checked={Boolean(form.extraGuestAllowed)}
//                   onChange={(e) => setValue("extraGuestAllowed", e.target.checked)}
//                 />
//                 <span>Allow extra guests (charged per extra guest)</span>
//               </label>
//             </>
//           )}

//           {step === 2 && (
//             <>
//               <h3 className="vr-sub">Cover image</h3>
//               <div className="vr-cover">
//                 <div className="vr-cover-box">
//                   {shownCover ? <img src={shownCover} alt="Cover preview" /> : (
//                     <div className="vr-placeholder"><span>▧</span><strong>No cover image</strong></div>
//                   )}
//                 </div>
//                 <div className="vr-cover-side">
//                   <p>The main photo shown in your room list. JPG, PNG, WEBP or AVIF, max {MAX_MB} MB.</p>
//                   <label className="vr-btn secondary file">
//                     Choose cover image
//                     <input type="file" accept="image/jpeg,image/png,image/webp,image/avif" onChange={onCoverPick} />
//                   </label>
//                   {newCover && (
//                     <button type="button" className="vr-link" onClick={() => setNewCover(null)}>
//                       Remove new cover
//                     </button>
//                   )}
//                 </div>
//               </div>

//               <div className="vr-row-between">
//                 <div>
//                   <h3 className="vr-sub tight">Gallery</h3>
//                   <small className="vr-muted">{totalGallery} of {MAX_GALLERY} images</small>
//                 </div>
//                 <label className="vr-btn secondary file">
//                   + Add images
//                   <input type="file" multiple accept="image/jpeg,image/png,image/webp,image/avif" onChange={onGalleryPick} />
//                 </label>
//               </div>

//               {totalGallery === 0 ? (
//                 <div className="vr-gallery-empty">Selected gallery images will appear here.</div>
//               ) : (
//                 <div className="vr-thumbs">
//                   {existingImages.map((url, i) => (
//                     <div className="vr-thumb" key={url}>
//                       <img src={url} alt={`Saved ${i + 1}`} />
//                       {existingCover === url && <span className="vr-tag cover">Cover</span>}
//                       {existingCover !== url && !newCover && <span className="vr-tag">Saved</span>}
//                       <div className="vr-thumb-actions">
//                         {existingCover !== url && (
//                           <button type="button" onClick={() => { setExistingCover(url); setNewCover(null); }}>
//                             Set cover
//                           </button>
//                         )}
//                         <button type="button" className="danger" onClick={() => removeExisting(url)}>Remove</button>
//                       </div>
//                     </div>
//                   ))}
//                   {galleryPreviews.map((p, i) => (
//                     <div className="vr-thumb" key={`${p.file.name}-${i}`}>
//                       <img src={p.url} alt={p.file.name} />
//                       <span className="vr-tag new">New</span>
//                       <div className="vr-thumb-actions">
//                         <button type="button" className="danger" onClick={() => setNewImages((x) => x.filter((_, idx) => idx !== i))}>
//                           Remove
//                         </button>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               )}

//               <h3 className="vr-sub">Amenities</h3>
//               <div className="vr-amenities">
//                 {AMENITIES.map((name) => (
//                   <label key={name} className={`vr-amenity ${form.amenities.includes(name) ? "on" : ""}`}>
//                     <input type="checkbox" checked={form.amenities.includes(name)} onChange={() => toggleAmenity(name)} />
//                     <span className="vr-box">{form.amenities.includes(name) ? "✓" : ""}</span>
//                     <span>{name}</span>
//                   </label>
//                 ))}
//               </div>

//               <Field label="Internal notes (only you can see this)" full>
//                 <textarea rows="3" {...bind("descriptionNotes")} placeholder="Optional notes for your team..." />
//               </Field>
//             </>
//           )}

//           {step === 3 && (
//             <div className="vr-review">
//               <div className="vr-review-top">
//                 <div className="vr-review-img">
//                   {shownCover ? <img src={shownCover} alt="Cover" /> : <span>⌂</span>}
//                 </div>
//                 <div>
//                   <span className="vr-kicker">SUMMARY</span>
//                   <h3>{form.roomName || "Untitled room"}</h3>
//                   <p className="vr-muted">
//                     {typeLabel(form.roomType)}{form.roomNumber ? ` · Room ${form.roomNumber}` : ""}
//                   </p>
//                   <strong className="vr-price-lg">{money(form.pricePerNight)} <small>/ night</small></strong>
//                 </div>
//               </div>

//               <div className="vr-facts">
//                 <div><small>Guests</small><strong>{form.maxGuests}</strong></div>
//                 <div><small>Beds</small><strong>{form.bedCount} · {cap(form.bedType)}</strong></div>
//                 <div><small>Total units</small><strong>{form.totalRooms}</strong></div>
//                 <div><small>Available</small><strong>{availableOf(form)}</strong></div>
//                 <div><small>Weekend price</small><strong>{money(form.weekendPrice)}</strong></div>
//                 <div><small>Photos</small><strong>{totalGallery + (newCover ? 1 : 0)}</strong></div>
//               </div>

//               <div className="vr-block">
//                 <h4>Description</h4>
//                 <p>{form.description || "No description provided."}</p>
//               </div>

//               <div className="vr-block">
//                 <h4>Amenities</h4>
//                 <div className="vr-chips">
//                   {form.amenities.length
//                     ? form.amenities.map((a) => <span key={a}>{a}</span>)
//                     : <small className="vr-muted">No amenities selected.</small>}
//                 </div>
//               </div>

//               <label className="vr-check">
//                 <input type="checkbox" checked={Boolean(form.isActive)} onChange={(e) => setValue("isActive", e.target.checked)} />
//                 <span>Make this room active (visible for booking)</span>
//               </label>
//             </div>
//           )}
//         </div>

//         <footer className="vr-modal-foot">
//           <span className="vr-muted">Step {step + 1} of {STEPS.length}</span>
//           <div className="vr-foot-actions">
//             <button type="button" className="vr-btn secondary" onClick={step === 0 ? onClose : goBack} disabled={saving}>
//               {step === 0 ? "Cancel" : "← Back"}
//             </button>
//             {step < STEPS.length - 1 ? (
//               <button type="button" className="vr-btn primary" onClick={goNext}>Continue →</button>
//             ) : (
//               <button type="submit" className="vr-btn primary" disabled={saving}>
//                 {saving ? "Saving..." : isEdit ? "Save changes" : "Create room"}
//               </button>
//             )}
//           </div>
//         </footer>
//       </form>
//     </div>
//   );
// }

// /* ---------- VIEW MODAL ---------- */

// function RoomViewModal({ room, villaName, onClose, onEdit }) {
//   useModalBehaviour(onClose, false);

//   const images = useMemo(() => {
//     const list = [room.coverImage, ...(room.images || [])].filter(Boolean);
//     return [...new Set(list)];
//   }, [room]);

//   const [active, setActive] = useState(0);
//   const date = (d) => (d ? new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "—");

//   const Item = ({ label, value }) => (
//     <div className="vr-item"><small>{label}</small><strong>{value === "" || value === undefined || value === null ? "—" : value}</strong></div>
//   );

//   return (
//     <div className="vr-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
//       <div className="vr-modal wide" role="dialog" aria-modal="true" aria-labelledby="vr-view-title">
//         <header className="vr-modal-head">
//           <div>
//             <span className="vr-kicker">ROOM DETAILS{villaName ? ` · ${villaName.toUpperCase()}` : ""}</span>
//             <h2 id="vr-view-title">{room.roomName}</h2>
//           </div>
//           <div className="vr-head-right">
//             <span className={`vr-status ${room.isActive ? "active" : "inactive"}`}>
//               {room.isActive ? "Active" : "Inactive"}
//             </span>
//             <button type="button" className="vr-icon-btn" onClick={onClose} aria-label="Close">×</button>
//           </div>
//         </header>

//         <div className="vr-modal-body">
//           <div className="vr-view-top">
//             <div className="vr-gallery">
//               <div className="vr-gallery-main">
//                 {images.length ? <img src={images[active]} alt={`${room.roomName} ${active + 1}`} /> : (
//                   <div className="vr-placeholder"><span>▧</span><strong>No photos added</strong></div>
//                 )}
//                 {images.length > 1 && (
//                   <>
//                     <button type="button" className="vr-nav left" onClick={() => setActive((a) => (a - 1 + images.length) % images.length)} aria-label="Previous">‹</button>
//                     <button type="button" className="vr-nav right" onClick={() => setActive((a) => (a + 1) % images.length)} aria-label="Next">›</button>
//                     <span className="vr-counter">{active + 1} / {images.length}</span>
//                   </>
//                 )}
//               </div>
//               {images.length > 1 && (
//                 <div className="vr-gallery-strip">
//                   {images.map((url, i) => (
//                     <button type="button" key={url} className={i === active ? "on" : ""} onClick={() => setActive(i)}>
//                       <img src={url} alt={`Thumbnail ${i + 1}`} />
//                     </button>
//                   ))}
//                 </div>
//               )}
//             </div>

//             <div className="vr-view-summary">
//               <p className="vr-muted">
//                 {typeLabel(room.roomType)}{room.roomNumber ? ` · Room ${room.roomNumber}` : ""}
//               </p>
//               <strong className="vr-price-lg">{money(room.pricePerNight)} <small>/ night</small></strong>
//               {Number(room.weekendPrice) > 0 && (
//                 <p className="vr-muted">Weekend: <b>{money(room.weekendPrice)}</b></p>
//               )}
//               <div className="vr-avail">
//                 <strong>{room.availableRooms ?? 0}</strong>
//                 <span>of {room.totalRooms || 0} units available</span>
//               </div>
//               <div className="vr-chips">
//                 {(room.amenities || []).length
//                   ? room.amenities.slice(0, 6).map((a) => <span key={a}>{a}</span>)
//                   : <small className="vr-muted">No amenities listed.</small>}
//                 {(room.amenities || []).length > 6 && <span>+{room.amenities.length - 6} more</span>}
//               </div>
//             </div>
//           </div>

//           <div className="vr-view-sections">
//             <section>
//               <h4>Room info</h4>
//               <div className="vr-items">
//                 <Item label="Room type" value={typeLabel(room.roomType)} />
//                 <Item label="Room number" value={room.roomNumber} />
//                 <Item label="Floor" value={room.floorNumber} />
//                 <Item label="Size" value={Number(room.roomSize) ? `${room.roomSize} ${room.roomSizeUnit === "sqm" ? "sq m" : "sq ft"}` : ""} />
//                 <Item label="Bed type" value={cap(room.bedType)} />
//                 <Item label="Beds" value={room.bedCount} />
//               </div>
//             </section>

//             <section>
//               <h4>Capacity</h4>
//               <div className="vr-items">
//                 <Item label="Max guests" value={room.maxGuests} />
//                 <Item label="Max adults" value={room.maxAdults} />
//                 <Item label="Max children" value={room.maxChildren} />
//                 <Item label="Extra guests" value={room.extraGuestAllowed ? `Allowed · ${money(room.extraGuestCharge)} each` : "Not allowed"} />
//               </div>
//             </section>

//             <section>
//               <h4>Inventory</h4>
//               <div className="vr-items">
//                 <Item label="Total units" value={room.totalRooms} />
//                 <Item label="Booked" value={room.bookedRooms} />
//                 <Item label="Blocked" value={room.blockedRooms} />
//                 <Item label="Available" value={room.availableRooms} />
//               </div>
//             </section>

//             <section>
//               <h4>Pricing</h4>
//               <div className="vr-items">
//                 <Item label="Per night" value={money(room.pricePerNight)} />
//                 <Item label="Weekend" value={Number(room.weekendPrice) ? money(room.weekendPrice) : "Same as nightly"} />
//                 <Item label="Extra guest" value={room.extraGuestAllowed ? money(room.extraGuestCharge) : "—"} />
//               </div>
//             </section>
//           </div>

//           <div className="vr-block">
//             <h4>Description</h4>
//             <p>{room.description || "No description provided."}</p>
//           </div>

//           <div className="vr-block">
//             <h4>All amenities</h4>
//             <div className="vr-chips">
//               {(room.amenities || []).length
//                 ? room.amenities.map((a) => <span key={a}>{a}</span>)
//                 : <small className="vr-muted">No amenities selected.</small>}
//             </div>
//           </div>

//           {room.descriptionNotes && (
//             <div className="vr-block">
//               <h4>Internal notes</h4>
//               <p>{room.descriptionNotes}</p>
//             </div>
//           )}

//           <p className="vr-muted vr-dates">Created {date(room.createdAt)} · Last updated {date(room.updatedAt)}</p>
//         </div>

//         <footer className="vr-modal-foot">
//           <span />
//           <div className="vr-foot-actions">
//             <button type="button" className="vr-btn secondary" onClick={onClose}>Close</button>
//             <button type="button" className="vr-btn primary" onClick={() => onEdit(room)}>✎ Edit room</button>
//           </div>
//         </footer>
//       </div>
//     </div>
//   );
// }

// /* ---------- DELETE CONFIRM ---------- */

// function ConfirmDelete({ room, busy, onCancel, onConfirm }) {
//   useModalBehaviour(onCancel, busy);
//   return (
//     <div className="vr-overlay" onMouseDown={(e) => e.target === e.currentTarget && !busy && onCancel()}>
//       <section className="vr-confirm" role="alertdialog" aria-modal="true" aria-labelledby="vr-del-title">
//         <div className="vr-confirm-icon">!</div>
//         <h2 id="vr-del-title">Delete this room?</h2>
//         <p>
//           <strong>{room.roomName}</strong> and all its photos will be permanently removed.
//           This action cannot be undone.
//         </p>
//         <div className="vr-confirm-actions">
//           <button className="vr-btn secondary" onClick={onCancel} disabled={busy}>Cancel</button>
//           <button className="vr-btn danger-solid" onClick={onConfirm} disabled={busy}>
//             {busy ? "Deleting..." : "Delete room"}
//           </button>
//         </div>
//       </section>
//     </div>
//   );
// }

// /* ---------- MAIN PAGE ---------- */

// export default function VillaRoomManager({ villaId: villaIdProp }) {
//   const [villas, setVillas] = useState([]);
//   const [villasLoading, setVillasLoading] = useState(!villaIdProp);
//   const [villaId, setVillaId] = useState(() => {
//     if (villaIdProp) return villaIdProp;
//     try { return sessionStorage.getItem(VILLA_KEY) || ""; } catch { return ""; }
//   });

//   const [rooms, setRooms] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [notice, setNotice] = useState("");
//   const [search, setSearch] = useState("");
//   const [statusFilter, setStatusFilter] = useState("all");
//   const [busyId, setBusyId] = useState(null);

//   const [formModal, setFormModal] = useState(null); // { mode, room }
//   const [viewRoom, setViewRoom] = useState(null);
//   const [deleteTarget, setDeleteTarget] = useState(null);
//   const [deleting, setDeleting] = useState(false);

//   // load villas for the selector
//   useEffect(() => {
//     if (villaIdProp) return;
//     let cancelled = false;
//     (async () => {
//       try {
//         const data = await apiRequest("/api/vendor/villas/my-villas");
//         if (cancelled) return;
//         const list = data.villas || data.data || [];
//         setVillas(list);
//         setVillaId((current) =>
//           current && list.some((v) => v._id === current) ? current : list[0]?._id || ""
//         );
//       } catch (err) {
//         if (!cancelled) setError(err.message);
//       } finally {
//         if (!cancelled) setVillasLoading(false);
//       }
//     })();
//     return () => { cancelled = true; };
//   }, [villaIdProp]);

//   useEffect(() => {
//     if (!villaId) return;
//     try { sessionStorage.setItem(VILLA_KEY, villaId); } catch {}
//   }, [villaId]);

//   const roomPath = useCallback(
//     (suffix = "") => `/api/vendor/villas/${encodeURIComponent(villaId)}/rooms${suffix}`,
//     [villaId]
//   );

//   const loadRooms = useCallback(
//     async (silent = false) => {
//       if (!villaId) return;
//       if (!silent) setLoading(true);
//       try {
//         const data = await apiRequest(roomPath());
//         setRooms(Array.isArray(data.rooms) ? data.rooms : []);
//       } catch (err) {
//         setError(err.message || "Unable to load rooms.");
//       } finally {
//         setLoading(false);
//       }
//     },
//     [roomPath, villaId]
//   );

//   useEffect(() => {
//     setRooms([]);
//     if (villaId) loadRooms();
//   }, [villaId, loadRooms]);

//   const villaName = villas.find((v) => v._id === villaId)?.name || "";

//   const filtered = useMemo(() => {
//     const q = search.trim().toLowerCase();
//     return rooms.filter((room) => {
//       const matchSearch =
//         !q ||
//         [room.roomName, room.roomNumber, typeLabel(room.roomType)]
//           .filter(Boolean)
//           .some((v) => String(v).toLowerCase().includes(q));
//       const matchStatus =
//         statusFilter === "all" ||
//         (statusFilter === "active" && room.isActive) ||
//         (statusFilter === "inactive" && !room.isActive);
//       return matchSearch && matchStatus;
//     });
//   }, [rooms, search, statusFilter]);

//   const stats = {
//     types: rooms.length,
//     active: rooms.filter((r) => r.isActive).length,
//     units: rooms.reduce((s, r) => s + Number(r.totalRooms || 0), 0),
//     available: rooms.reduce((s, r) => s + Number(r.availableRooms || 0), 0),
//   };

//   const handleSaved = (saved, mode) => {
//     if (saved?._id) {
//       setRooms((prev) =>
//         mode === "edit" ? prev.map((r) => (r._id === saved._id ? saved : r)) : [saved, ...prev]
//       );
//     }
//     setFormModal(null);
//     setError("");
//     setNotice(mode === "edit" ? "Room updated successfully." : "Room added successfully.");
//     loadRooms(true);
//   };

//   const toggleStatus = async (room) => {
//     setBusyId(room._id);
//     setError("");
//     setNotice("");
//     try {
//       const data = await apiRequest(roomPath(`/${room._id}/toggle-status`), { method: "PATCH" });
//       setRooms((prev) =>
//         prev.map((r) => (r._id === room._id ? data.room || { ...r, isActive: !r.isActive } : r))
//       );
//       setNotice(`Room ${room.isActive ? "deactivated" : "activated"}.`);
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setBusyId(null);
//     }
//   };

//   const confirmDelete = async () => {
//     if (!deleteTarget) return;
//     setDeleting(true);
//     setError("");
//     try {
//       await apiRequest(roomPath(`/${deleteTarget._id}`), { method: "DELETE" });
//       setRooms((prev) => prev.filter((r) => r._id !== deleteTarget._id));
//       setNotice("Room deleted successfully.");
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setDeleting(false);
//       setDeleteTarget(null);
//     }
//   };

//   const openView = async (room) => {
//     setViewRoom(room); // show instantly
//     try {
//       const data = await apiRequest(roomPath(`/${room._id}`));
//       if (data.room) setViewRoom(data.room);
//     } catch {
//       /* keep the list copy */
//     }
//   };

//   const startEdit = (room) => {
//     setViewRoom(null);
//     setNotice("");
//     setFormModal({ mode: "edit", room });
//   };

//   /* ----- guards ----- */

//   if (villasLoading) {
//     return (
//       <div className="vr-page">
//         <div className="vr-center"><span className="vr-spinner" /> Loading your villas...</div>
//       </div>
//     );
//   }

//   if (!villaId) {
//     return (
//       <div className="vr-page">
//         {error && <div className="vr-alert error"><span>{error}</span><button onClick={() => setError("")}>×</button></div>}
//         <div className="vr-empty">
//           <div className="vr-empty-icon">⌂</div>
//           <h3>Add a villa first</h3>
//           <p>Rooms belong to a villa. Create a villa from “Manage Villas”, then come back here to add its rooms.</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="vr-page">
//       <header className="vr-header">
//         <div>
//           <div className="vr-kicker">PROPERTY MANAGEMENT / VILLAS</div>
//           <h1>Villa rooms</h1>
//           <p>Manage room types, photos, pricing and availability.</p>
//         </div>
//         <div className="vr-header-actions">
//           <button className="vr-btn secondary" onClick={() => loadRooms()} disabled={loading}>↻ Refresh</button>
//           <button className="vr-btn primary" onClick={() => { setNotice(""); setFormModal({ mode: "create", room: null }); }}>
//             ＋ Add room
//           </button>
//         </div>
//       </header>

//       {!villaIdProp && villas.length > 0 && (
//         <div className="vr-villa-picker">
//           <label htmlFor="vr-villa">Villa</label>
//           <select id="vr-villa" value={villaId} onChange={(e) => setVillaId(e.target.value)}>
//             {villas.map((v) => <option key={v._id} value={v._id}>{v.name}</option>)}
//           </select>
//         </div>
//       )}

//       {notice && (
//         <div className="vr-alert success"><span>✓ {notice}</span><button onClick={() => setNotice("")}>×</button></div>
//       )}
//       {error && !formModal && (
//         <div className="vr-alert error" role="alert"><span>{error}</span><button onClick={() => setError("")}>×</button></div>
//       )}

//       <section className="vr-stats">
//         <div className="vr-stat"><span className="vr-stat-icon">▦</span><div><small>Room types</small><strong>{stats.types}</strong></div></div>
//         <div className="vr-stat"><span className="vr-stat-icon green">✓</span><div><small>Active</small><strong>{stats.active}</strong></div></div>
//         <div className="vr-stat"><span className="vr-stat-icon">⌂</span><div><small>Total units</small><strong>{stats.units}</strong></div></div>
//         <div className="vr-stat"><span className="vr-stat-icon amber">◷</span><div><small>Available units</small><strong>{stats.available}</strong></div></div>
//       </section>

//       <section className="vr-panel">
//         <div className="vr-toolbar">
//           <div>
//             <h2>Room inventory</h2>
//             <p>{filtered.length} room type(s){villaName ? ` in ${villaName}` : ""}</p>
//           </div>
//           <div className="vr-filters">
//             <div className="vr-search">
//               <span>⌕</span>
//               <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search room..." aria-label="Search rooms" />
//             </div>
//             <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} aria-label="Filter by status">
//               <option value="all">All statuses</option>
//               <option value="active">Active</option>
//               <option value="inactive">Inactive</option>
//             </select>
//           </div>
//         </div>

//         {loading ? (
//           <div className="vr-center"><span className="vr-spinner" /> Loading rooms...</div>
//         ) : filtered.length === 0 ? (
//           <div className="vr-empty">
//             <div className="vr-empty-icon">⌂</div>
//             <h3>{rooms.length ? "No matching rooms" : "No rooms added yet"}</h3>
//             <p>{rooms.length ? "Try changing the search or status filter." : "Add your first room to start managing this villa's inventory."}</p>
//             {!rooms.length && (
//               <button className="vr-btn primary" onClick={() => setFormModal({ mode: "create", room: null })}>＋ Add your first room</button>
//             )}
//           </div>
//         ) : (
//           <div className="vr-table-wrap">
//             <table className="vr-table">
//               <thead>
//                 <tr>
//                   <th>Room</th><th>Type</th><th>Capacity</th><th>Availability</th>
//                   <th>Price / night</th><th>Status</th><th className="right">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {filtered.map((room) => {
//                   const img = room.coverImage || room.images?.[0];
//                   const busy = busyId === room._id;
//                   return (
//                     <tr key={room._id}>
//                       <td>
//                         <div className="vr-room-cell">
//                           <button type="button" className="vr-room-thumb" onClick={() => openView(room)} aria-label={`View ${room.roomName}`}>
//                             {img ? <img src={img} alt={room.roomName} loading="lazy" /> : <span>⌂</span>}
//                           </button>
//                           <div>
//                             <strong>{room.roomName}</strong>
//                             <small>{room.roomNumber ? `Room ${room.roomNumber}` : `${room.bedCount || 1} × ${cap(room.bedType)} bed`}</small>
//                           </div>
//                         </div>
//                       </td>
//                       <td>{typeLabel(room.roomType)}</td>
//                       <td>{room.maxGuests || 1} guests</td>
//                       <td>
//                         <strong>{room.availableRooms ?? 0}</strong>
//                         <span className="vr-muted"> / {room.totalRooms || 0}</span>
//                       </td>
//                       <td className="vr-price">{money(room.pricePerNight)}</td>
//                       <td>
//                         <span className={`vr-status ${room.isActive ? "active" : "inactive"}`}>
//                           {room.isActive ? "Active" : "Inactive"}
//                         </span>
//                       </td>
//                       <td>
//                         <div className="vr-actions">
//                           <button onClick={() => openView(room)} disabled={busy}>View</button>
//                           <button onClick={() => startEdit(room)} disabled={busy}>Edit</button>
//                           <button onClick={() => toggleStatus(room)} disabled={busy}>
//                             {room.isActive ? "Disable" : "Enable"}
//                           </button>
//                           <button className="danger" onClick={() => setDeleteTarget(room)} disabled={busy}>Delete</button>
//                         </div>
//                       </td>
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </section>

//       {formModal && (
//         <RoomFormModal
//           key={`${formModal.mode}-${formModal.room?._id || "new"}`}
//           mode={formModal.mode}
//           room={formModal.room}
//           roomPath={roomPath}
//           onClose={() => setFormModal(null)}
//           onSaved={handleSaved}
//         />
//       )}

//       {viewRoom && (
//         <RoomViewModal
//           key={viewRoom._id}
//           room={viewRoom}
//           villaName={villaName}
//           onClose={() => setViewRoom(null)}
//           onEdit={startEdit}
//         />
//       )}

//       {deleteTarget && (
//         <ConfirmDelete
//           room={deleteTarget}
//           busy={deleting}
//           onCancel={() => setDeleteTarget(null)}
//           onConfirm={confirmDelete}
//         />
//       )}
//     </div>
//   );
// }



import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import "./VillaRoomManager.css";

const API_BASE = (
  process.env.REACT_APP_API_URL || "https://bmtvendorvendorfinal.onrender.com"
).replace(/\/$/, "");

const VILLA_KEY = "bmtVillaRoomSelectedVilla";
const MAX_GALLERY = 20;
const MAX_MB = 5;

const EMPTY_FORM = {
  roomName: "",
  roomNumber: "",
  roomType: "standard",
  description: "",
  bedType: "double",
  bedCount: "1",
  maxGuests: "2",
  maxAdults: "2",
  maxChildren: "0",
  floorNumber: "",
  roomSize: "0",
  roomSizeUnit: "sqft",
  totalRooms: "1",
  bookedRooms: "0",
  blockedRooms: "0",
  pricePerNight: "",
  weekendPrice: "0",
  extraGuestAllowed: false,
  extraGuestCharge: "0",
  amenities: [],
  descriptionNotes: "",
  isActive: true,
};

const TEXT_FIELDS = [
  "roomName", "roomNumber", "roomType", "description", "bedType",
  "floorNumber", "roomSizeUnit", "descriptionNotes",
];

const NUM_FIELDS = [
  "bedCount", "maxGuests", "maxAdults", "maxChildren", "roomSize",
  "totalRooms", "bookedRooms", "blockedRooms", "pricePerNight",
  "weekendPrice", "extraGuestCharge",
];

const ROOM_TYPES = [
  ["standard", "Standard Room"],
  ["deluxe", "Deluxe Room"],
  ["super-deluxe", "Super Deluxe"],
  ["premium", "Premium Room"],
  ["suite", "Suite"],
  ["master-bedroom", "Master Bedroom"],
  ["family-room", "Family Room"],
  ["private-room", "Private Room"],
  ["shared-room", "Shared Room"],
  ["other", "Other"],
];

const BED_TYPES = ["single", "twin", "double", "queen", "king", "bunk", "multiple", "other"];

const AMENITIES = [
  "Air Conditioning", "Wi-Fi", "Television", "Attached Bathroom", "Balcony",
  "Mountain View", "Garden View", "Wardrobe", "Refrigerator", "Room Service",
  "Work Desk", "Hot Water", "Heating", "Private Entrance",
];

const STEPS = [
  { title: "Room details", subtitle: "Basic information" },
  { title: "Capacity & price", subtitle: "Guests, inventory, pricing" },
  { title: "Photos & amenities", subtitle: "Images and facilities" },
  { title: "Review & save", subtitle: "Confirm your details" },
];

const typeLabel = (v) => ROOM_TYPES.find(([k]) => k === v)?.[1] || v || "Standard";
const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : "");
const money = (v) => `₹${Number(v || 0).toLocaleString("en-IN")}`;
const availableOf = (f) =>
  Math.max(0, Number(f.totalRooms || 0) - Number(f.bookedRooms || 0) - Number(f.blockedRooms || 0));

const formFromRoom = (room) => {
  const next = { ...EMPTY_FORM };
  Object.keys(EMPTY_FORM).forEach((key) => {
    if (room[key] !== undefined && room[key] !== null) next[key] = room[key];
  });
  NUM_FIELDS.forEach((key) => (next[key] = String(next[key] ?? "")));
  next.amenities = Array.isArray(room.amenities) ? [...room.amenities] : [];
  return next;
};

async function apiRequest(path, options = {}) {
  const token = localStorage.getItem("vendorToken");

  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      ...(options.body instanceof FormData ? {} : { "Content-Type": "application/json" }),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok || data.success === false) {
    throw new Error(
      data.message ||
        (response.status === 401
          ? "Session expired. Please log in again."
          : `Request failed (${response.status})`)
    );
  }
  return data;
}

/* ---------- small shared pieces ---------- */

function Field({ label, required, hint, full, children }) {
  return (
    <div className={`vr-field ${full ? "full" : ""}`}>
      <label>
        {label} {required && <span className="vr-required">*</span>}
      </label>
      {children}
      {hint && <small>{hint}</small>}
    </div>
  );
}

function useModalBehaviour(onClose, locked) {
  useEffect(() => {
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => {
      if (e.key === "Escape" && !locked) onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = previous;
      window.removeEventListener("keydown", onKey);
    };
  }, [onClose, locked]);
}

/* ---------- ADD / EDIT MODAL ---------- */

function RoomFormModal({ mode, room, roomPath, onClose, onSaved }) {
  const isEdit = mode === "edit";

  const [step, setStep] = useState(0);
  const [form, setForm] = useState(() => (room ? formFromRoom(room) : { ...EMPTY_FORM }));
  const [existingImages, setExistingImages] = useState(() => (room?.images ? [...room.images] : []));
  const [existingCover, setExistingCover] = useState(room?.coverImage || "");
  const [newImages, setNewImages] = useState([]);
  const [newCover, setNewCover] = useState(null);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const topRef = useRef(null);
  useEffect(() => {
    topRef.current?.scrollIntoView({ block: "start" });
  }, []);

  const galleryPreviews = useMemo(
    () => newImages.map((file) => ({ file, url: URL.createObjectURL(file) })),
    [newImages]
  );
  useEffect(
    () => () => galleryPreviews.forEach((p) => URL.revokeObjectURL(p.url)),
    [galleryPreviews]
  );

  const coverPreview = useMemo(
    () => (newCover ? URL.createObjectURL(newCover) : ""),
    [newCover]
  );
  useEffect(
    () => () => {
      if (coverPreview) URL.revokeObjectURL(coverPreview);
    },
    [coverPreview]
  );

  const shownCover = coverPreview || existingCover || existingImages[0] || "";
  const totalGallery = existingImages.length + newImages.length;

  const setValue = (key, value) => setForm((p) => ({ ...p, [key]: value }));
  const bind = (key) => ({
    value: form[key] ?? "",
    onChange: (e) => setValue(key, e.target.value),
  });

  const toggleAmenity = (name) =>
    setForm((p) => ({
      ...p,
      amenities: p.amenities.includes(name)
        ? p.amenities.filter((a) => a !== name)
        : [...p.amenities, name],
    }));

  const validate = (index) => {
    if (index === 0) {
      if (!form.roomName.trim()) return "Please enter a room name.";
    }
    if (index === 1) {
      const n = (k) => Number(form[k]);
      if (!(n("bedCount") >= 1)) return "Number of beds must be at least 1.";
      if (!(n("maxGuests") >= 1)) return "Maximum guests must be at least 1.";
      if (!(n("maxAdults") >= 1)) return "Maximum adults must be at least 1.";
      if (!(n("maxChildren") >= 0)) return "Maximum children cannot be negative.";
      if (!Number.isInteger(n("totalRooms")) || n("totalRooms") < 1)
        return "Total rooms must be a whole number of at least 1.";
      if (!Number.isInteger(n("bookedRooms")) || n("bookedRooms") < 0)
        return "Booked rooms must be a whole number (0 or more).";
      if (!Number.isInteger(n("blockedRooms")) || n("blockedRooms") < 0)
        return "Blocked rooms must be a whole number (0 or more).";
      if (n("bookedRooms") + n("blockedRooms") > n("totalRooms"))
        return "Booked and blocked rooms cannot exceed total rooms.";
      if (form.pricePerNight === "" || !(n("pricePerNight") >= 0))
        return "Please enter a valid price per night.";
      if (!(n("weekendPrice") >= 0)) return "Weekend price cannot be negative.";
    }
    if (index === 2) {
      if (!shownCover && totalGallery === 0) return "Please add at least one room photo.";
      if (totalGallery > MAX_GALLERY) return `Maximum ${MAX_GALLERY} gallery images allowed.`;
    }
    return "";
  };

  const goNext = () => {
    const message = validate(step);
    if (message) return setError(message);
    setError("");
    setStep((s) => Math.min(s + 1, STEPS.length - 1));
  };

  const goBack = () => {
    setError("");
    setStep((s) => Math.max(s - 1, 0));
  };

  const pickFiles = (event, onlyFirst) => {
    const files = Array.from(event.target.files || []);
    event.target.value = "";
    if (!files.length) return [];

    const ok = [];
    for (const file of files) {
      if (!file.type.startsWith("image/")) {
        setError(`${file.name} is not an image.`);
        continue;
      }
      if (file.size > MAX_MB * 1024 * 1024) {
        setError(`${file.name} is larger than ${MAX_MB} MB.`);
        continue;
      }
      ok.push(file);
    }
    return onlyFirst ? ok.slice(0, 1) : ok;
  };

  const onGalleryPick = (event) => {
    const ok = pickFiles(event, false);
    if (!ok.length) return;
    const room_left = MAX_GALLERY - totalGallery;
    if (ok.length > room_left) setError(`Only ${MAX_GALLERY} gallery images are allowed in total.`);
    else setError("");
    setNewImages((p) => [...p, ...ok.slice(0, Math.max(room_left, 0))]);
  };

  const onCoverPick = (event) => {
    const [file] = pickFiles(event, true);
    if (!file) return;
    setNewCover(file);
    setError("");
  };

  const removeExisting = (url) => {
    setExistingImages((p) => p.filter((u) => u !== url));
    if (existingCover === url) setExistingCover("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (step !== STEPS.length - 1) return;

    for (let i = 0; i < STEPS.length - 1; i += 1) {
      const message = validate(i);
      if (message) {
        setStep(i);
        setError(message);
        return;
      }
    }

    setSaving(true);
    setError("");

    try {
      const body = new FormData();

      TEXT_FIELDS.forEach((f) => body.append(f, String(form[f] ?? "").trim()));
      NUM_FIELDS.forEach((f) => body.append(f, String(Number(form[f]) || 0)));
      body.append("extraGuestAllowed", String(Boolean(form.extraGuestAllowed)));
      body.append("isActive", String(Boolean(form.isActive)));
      body.append("amenities", JSON.stringify(form.amenities));

      if (isEdit) {
        const originalUrls = room?.images || [];
        const originalIds = room?.imagePublicIds || [];
        const keptIds = existingImages
          .map((url) => originalIds[originalUrls.indexOf(url)])
          .filter(Boolean);

        body.append("existingImages", JSON.stringify(existingImages));
        body.append("existingImagePublicIds", JSON.stringify(keptIds));
        body.append("existingCoverImage", existingCover || "");
      }

      if (newCover) body.append("coverImage", newCover);
      newImages.forEach((file) => body.append("images", file));

      const data = await apiRequest(isEdit ? roomPath(`/${room._id}`) : roomPath(), {
        method: isEdit ? "PUT" : "POST",
        body,
      });

      onSaved(data.room, mode);
    } catch (err) {
      setError(err.message || "Unable to save room.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="vr-formpage" ref={topRef}>
      <form
        className="vr-modal page"
        onSubmit={handleSubmit}
        onKeyDown={(e) => {
          if (e.key === "Enter" && e.target.tagName === "INPUT" && e.target.type !== "file")
            e.preventDefault();
        }}
      >
        <header className="vr-modal-head">
          <div>
            <span className="vr-kicker">{isEdit ? "EDIT ROOM" : "NEW ROOM"}</span>
            <h2 id="vr-form-title">
              {isEdit ? `Edit “${room?.roomName || "room"}”` : "Add a new room"}
            </h2>
          </div>
          <button type="button" className="vr-btn secondary" onClick={onClose} disabled={saving}>
            ← Back to rooms
          </button>
        </header>

        <div className="vr-stepper">
          {STEPS.map((item, index) => (
            <button
              type="button"
              key={item.title}
              className={`vr-step ${index === step ? "current" : ""} ${index < step ? "done" : ""}`}
              onClick={() => {
                if (isEdit || index < step) {
                  setStep(index);
                  setError("");
                }
              }}
            >
              <span className="vr-step-no">{index < step ? "✓" : index + 1}</span>
              <span className="vr-step-text">
                <strong>{item.title}</strong>
                <small>{item.subtitle}</small>
              </span>
            </button>
          ))}
        </div>

        <div className="vr-progress"><div style={{ width: `${((step + 1) / STEPS.length) * 100}%` }} /></div>

        <div className="vr-modal-body">
          {error && (
            <div className="vr-alert error" role="alert">
              <span>{error}</span>
              <button type="button" onClick={() => setError("")}>×</button>
            </div>
          )}

          {step === 0 && (
            <div className="vr-grid">
              <Field label="Room name" required>
                <input {...bind("roomName")} placeholder="e.g. Deluxe Garden Room" maxLength={120} autoFocus />
              </Field>
              <Field label="Room number / identifier">
                <input {...bind("roomNumber")} placeholder="e.g. R-101" />
              </Field>
              <Field label="Room type" required>
                <select {...bind("roomType")}>
                  {ROOM_TYPES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                </select>
              </Field>
              <Field label="Floor">
                <input {...bind("floorNumber")} placeholder="e.g. Ground floor" />
              </Field>
              <Field label="Room size">
                <div className="vr-inline">
                  <input type="number" min="0" {...bind("roomSize")} />
                  <select {...bind("roomSizeUnit")}>
                    <option value="sqft">sq ft</option>
                    <option value="sqm">sq m</option>
                  </select>
                </div>
              </Field>
              <div />
              <Field label="Description" full>
                <textarea rows="4" {...bind("description")} placeholder="Describe the room, view and important details..." />
              </Field>
            </div>
          )}

          {step === 1 && (
            <>
              <h3 className="vr-sub">Beds & guests</h3>
              <div className="vr-grid three">
                <Field label="Bed type" required>
                  <select {...bind("bedType")}>
                    {BED_TYPES.map((v) => <option key={v} value={v}>{cap(v)}</option>)}
                  </select>
                </Field>
                <Field label="Number of beds" required>
                  <input type="number" min="1" {...bind("bedCount")} />
                </Field>
                <Field label="Maximum guests" required>
                  <input type="number" min="1" {...bind("maxGuests")} />
                </Field>
                <Field label="Maximum adults" required>
                  <input type="number" min="1" {...bind("maxAdults")} />
                </Field>
                <Field label="Maximum children">
                  <input type="number" min="0" {...bind("maxChildren")} />
                </Field>
              </div>

              <h3 className="vr-sub">Inventory</h3>
              <div className="vr-grid three">
                <Field label="Total rooms / units" required>
                  <input type="number" min="1" {...bind("totalRooms")} />
                </Field>
                <Field label="Already booked">
                  <input type="number" min="0" {...bind("bookedRooms")} />
                </Field>
                <Field label="Blocked rooms">
                  <input type="number" min="0" {...bind("blockedRooms")} />
                </Field>
              </div>
              <div className="vr-note">
                <strong>Available units</strong>
                <span>{availableOf(form)} of {Number(form.totalRooms || 0)}</span>
              </div>

              <h3 className="vr-sub">Pricing</h3>
              <div className="vr-grid three">
                <Field label="Price per night (₹)" required>
                  <input type="number" min="0" {...bind("pricePerNight")} placeholder="e.g. 2500" />
                </Field>
                <Field label="Weekend price (₹)">
                  <input type="number" min="0" {...bind("weekendPrice")} />
                </Field>
                <Field label="Extra guest charge (₹)">
                  <input
                    type="number"
                    min="0"
                    {...bind("extraGuestCharge")}
                    disabled={!form.extraGuestAllowed}
                  />
                </Field>
              </div>
              <label className="vr-check">
                <input
                  type="checkbox"
                  checked={Boolean(form.extraGuestAllowed)}
                  onChange={(e) => setValue("extraGuestAllowed", e.target.checked)}
                />
                <span>Allow extra guests (charged per extra guest)</span>
              </label>
            </>
          )}

          {step === 2 && (
            <>
              <h3 className="vr-sub">Cover image</h3>
              <div className="vr-cover">
                <div className="vr-cover-box">
                  {shownCover ? <img src={shownCover} alt="Cover preview" /> : (
                    <div className="vr-placeholder"><span>▧</span><strong>No cover image</strong></div>
                  )}
                </div>
                <div className="vr-cover-side">
                  <p>The main photo shown in your room list. JPG, PNG, WEBP or AVIF, max {MAX_MB} MB.</p>
                  <label className="vr-btn secondary file">
                    Choose cover image
                    <input type="file" accept="image/jpeg,image/png,image/webp,image/avif" onChange={onCoverPick} />
                  </label>
                  {newCover && (
                    <button type="button" className="vr-link" onClick={() => setNewCover(null)}>
                      Remove new cover
                    </button>
                  )}
                </div>
              </div>

              <div className="vr-row-between">
                <div>
                  <h3 className="vr-sub tight">Gallery</h3>
                  <small className="vr-muted">{totalGallery} of {MAX_GALLERY} images</small>
                </div>
                <label className="vr-btn secondary file">
                  + Add images
                  <input type="file" multiple accept="image/jpeg,image/png,image/webp,image/avif" onChange={onGalleryPick} />
                </label>
              </div>

              {totalGallery === 0 ? (
                <div className="vr-gallery-empty">Selected gallery images will appear here.</div>
              ) : (
                <div className="vr-thumbs">
                  {existingImages.map((url, i) => (
                    <div className="vr-thumb" key={url}>
                      <img src={url} alt={`Saved ${i + 1}`} />
                      {existingCover === url && <span className="vr-tag cover">Cover</span>}
                      {existingCover !== url && !newCover && <span className="vr-tag">Saved</span>}
                      <div className="vr-thumb-actions">
                        {existingCover !== url && (
                          <button type="button" onClick={() => { setExistingCover(url); setNewCover(null); }}>
                            Set cover
                          </button>
                        )}
                        <button type="button" className="danger" onClick={() => removeExisting(url)}>Remove</button>
                      </div>
                    </div>
                  ))}
                  {galleryPreviews.map((p, i) => (
                    <div className="vr-thumb" key={`${p.file.name}-${i}`}>
                      <img src={p.url} alt={p.file.name} />
                      <span className="vr-tag new">New</span>
                      <div className="vr-thumb-actions">
                        <button type="button" className="danger" onClick={() => setNewImages((x) => x.filter((_, idx) => idx !== i))}>
                          Remove
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              <h3 className="vr-sub">Amenities</h3>
              <div className="vr-amenities">
                {AMENITIES.map((name) => (
                  <label key={name} className={`vr-amenity ${form.amenities.includes(name) ? "on" : ""}`}>
                    <input type="checkbox" checked={form.amenities.includes(name)} onChange={() => toggleAmenity(name)} />
                    <span className="vr-box">{form.amenities.includes(name) ? "✓" : ""}</span>
                    <span>{name}</span>
                  </label>
                ))}
              </div>

              <Field label="Internal notes (only you can see this)" full>
                <textarea rows="3" {...bind("descriptionNotes")} placeholder="Optional notes for your team..." />
              </Field>
            </>
          )}

          {step === 3 && (
            <div className="vr-review">
              <div className="vr-review-top">
                <div className="vr-review-img">
                  {shownCover ? <img src={shownCover} alt="Cover" /> : <span>⌂</span>}
                </div>
                <div>
                  <span className="vr-kicker">SUMMARY</span>
                  <h3>{form.roomName || "Untitled room"}</h3>
                  <p className="vr-muted">
                    {typeLabel(form.roomType)}{form.roomNumber ? ` · Room ${form.roomNumber}` : ""}
                  </p>
                  <strong className="vr-price-lg">{money(form.pricePerNight)} <small>/ night</small></strong>
                </div>
              </div>

              <div className="vr-facts">
                <div><small>Guests</small><strong>{form.maxGuests}</strong></div>
                <div><small>Beds</small><strong>{form.bedCount} · {cap(form.bedType)}</strong></div>
                <div><small>Total units</small><strong>{form.totalRooms}</strong></div>
                <div><small>Available</small><strong>{availableOf(form)}</strong></div>
                <div><small>Weekend price</small><strong>{money(form.weekendPrice)}</strong></div>
                <div><small>Photos</small><strong>{totalGallery + (newCover ? 1 : 0)}</strong></div>
              </div>

              <div className="vr-block">
                <h4>Description</h4>
                <p>{form.description || "No description provided."}</p>
              </div>

              <div className="vr-block">
                <h4>Amenities</h4>
                <div className="vr-chips">
                  {form.amenities.length
                    ? form.amenities.map((a) => <span key={a}>{a}</span>)
                    : <small className="vr-muted">No amenities selected.</small>}
                </div>
              </div>

              <label className="vr-check">
                <input type="checkbox" checked={Boolean(form.isActive)} onChange={(e) => setValue("isActive", e.target.checked)} />
                <span>Make this room active (visible for booking)</span>
              </label>
            </div>
          )}
        </div>

        <footer className="vr-modal-foot">
          <span className="vr-muted">Step {step + 1} of {STEPS.length}</span>
          <div className="vr-foot-actions">
            <button type="button" className="vr-btn secondary" onClick={step === 0 ? onClose : goBack} disabled={saving}>
              {step === 0 ? "Cancel" : "← Back"}
            </button>
            {step < STEPS.length - 1 ? (
              <button type="button" className="vr-btn primary" onClick={goNext}>Continue →</button>
            ) : (
              <button type="submit" className="vr-btn primary" disabled={saving}>
                {saving ? "Saving..." : isEdit ? "Save changes" : "Create room"}
              </button>
            )}
          </div>
        </footer>
      </form>
    </div>
  );
}

/* ---------- VIEW MODAL ---------- */

function RoomViewModal({ room, villaName, onClose, onEdit }) {
  const topRef = useRef(null);
  useEffect(() => {
    topRef.current?.scrollIntoView({ block: "start" });
  }, []);

  const images = useMemo(() => {
    const list = [room.coverImage, ...(room.images || [])].filter(Boolean);
    return [...new Set(list)];
  }, [room]);

  const [active, setActive] = useState(0);
  const date = (d) => (d ? new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "—");

  const Item = ({ label, value }) => (
    <div className="vr-item"><small>{label}</small><strong>{value === "" || value === undefined || value === null ? "—" : value}</strong></div>
  );

  return (
    <div className="vr-formpage" ref={topRef}>
      <div className="vr-modal wide page">
        <header className="vr-modal-head">
          <div>
            <span className="vr-kicker">ROOM DETAILS{villaName ? ` · ${villaName.toUpperCase()}` : ""}</span>
            <h2 id="vr-view-title">{room.roomName}</h2>
          </div>
          <div className="vr-head-right">
            <span className={`vr-status ${room.isActive ? "active" : "inactive"}`}>
              {room.isActive ? "Active" : "Inactive"}
            </span>
            <button type="button" className="vr-btn secondary" onClick={onClose}>← Back to rooms</button>
          </div>
        </header>

        <div className="vr-modal-body">
          <div className="vr-view-top">
            <div className="vr-gallery">
              <div className="vr-gallery-main">
                {images.length ? <img src={images[active]} alt={`${room.roomName} ${active + 1}`} /> : (
                  <div className="vr-placeholder"><span>▧</span><strong>No photos added</strong></div>
                )}
                {images.length > 1 && (
                  <>
                    <button type="button" className="vr-nav left" onClick={() => setActive((a) => (a - 1 + images.length) % images.length)} aria-label="Previous">‹</button>
                    <button type="button" className="vr-nav right" onClick={() => setActive((a) => (a + 1) % images.length)} aria-label="Next">›</button>
                    <span className="vr-counter">{active + 1} / {images.length}</span>
                  </>
                )}
              </div>
              {images.length > 1 && (
                <div className="vr-gallery-strip">
                  {images.map((url, i) => (
                    <button type="button" key={url} className={i === active ? "on" : ""} onClick={() => setActive(i)}>
                      <img src={url} alt={`Thumbnail ${i + 1}`} />
                    </button>
                  ))}
                </div>
              )}
            </div>

            <div className="vr-view-summary">
              <p className="vr-muted">
                {typeLabel(room.roomType)}{room.roomNumber ? ` · Room ${room.roomNumber}` : ""}
              </p>
              <strong className="vr-price-lg">{money(room.pricePerNight)} <small>/ night</small></strong>
              {Number(room.weekendPrice) > 0 && (
                <p className="vr-muted">Weekend: <b>{money(room.weekendPrice)}</b></p>
              )}
              <div className="vr-avail">
                <strong>{room.availableRooms ?? 0}</strong>
                <span>of {room.totalRooms || 0} units available</span>
              </div>
              <div className="vr-chips">
                {(room.amenities || []).length
                  ? room.amenities.slice(0, 6).map((a) => <span key={a}>{a}</span>)
                  : <small className="vr-muted">No amenities listed.</small>}
                {(room.amenities || []).length > 6 && <span>+{room.amenities.length - 6} more</span>}
              </div>
            </div>
          </div>

          <div className="vr-view-sections">
            <section>
              <h4>Room info</h4>
              <div className="vr-items">
                <Item label="Room type" value={typeLabel(room.roomType)} />
                <Item label="Room number" value={room.roomNumber} />
                <Item label="Floor" value={room.floorNumber} />
                <Item label="Size" value={Number(room.roomSize) ? `${room.roomSize} ${room.roomSizeUnit === "sqm" ? "sq m" : "sq ft"}` : ""} />
                <Item label="Bed type" value={cap(room.bedType)} />
                <Item label="Beds" value={room.bedCount} />
              </div>
            </section>

            <section>
              <h4>Capacity</h4>
              <div className="vr-items">
                <Item label="Max guests" value={room.maxGuests} />
                <Item label="Max adults" value={room.maxAdults} />
                <Item label="Max children" value={room.maxChildren} />
                <Item label="Extra guests" value={room.extraGuestAllowed ? `Allowed · ${money(room.extraGuestCharge)} each` : "Not allowed"} />
              </div>
            </section>

            <section>
              <h4>Inventory</h4>
              <div className="vr-items">
                <Item label="Total units" value={room.totalRooms} />
                <Item label="Booked" value={room.bookedRooms} />
                <Item label="Blocked" value={room.blockedRooms} />
                <Item label="Available" value={room.availableRooms} />
              </div>
            </section>

            <section>
              <h4>Pricing</h4>
              <div className="vr-items">
                <Item label="Per night" value={money(room.pricePerNight)} />
                <Item label="Weekend" value={Number(room.weekendPrice) ? money(room.weekendPrice) : "Same as nightly"} />
                <Item label="Extra guest" value={room.extraGuestAllowed ? money(room.extraGuestCharge) : "—"} />
              </div>
            </section>
          </div>

          <div className="vr-block">
            <h4>Description</h4>
            <p>{room.description || "No description provided."}</p>
          </div>

          <div className="vr-block">
            <h4>All amenities</h4>
            <div className="vr-chips">
              {(room.amenities || []).length
                ? room.amenities.map((a) => <span key={a}>{a}</span>)
                : <small className="vr-muted">No amenities selected.</small>}
            </div>
          </div>

          {room.descriptionNotes && (
            <div className="vr-block">
              <h4>Internal notes</h4>
              <p>{room.descriptionNotes}</p>
            </div>
          )}

          <p className="vr-muted vr-dates">Created {date(room.createdAt)} · Last updated {date(room.updatedAt)}</p>
        </div>

        <footer className="vr-modal-foot">
          <span />
          <div className="vr-foot-actions">
            <button type="button" className="vr-btn secondary" onClick={onClose}>Close</button>
            <button type="button" className="vr-btn primary" onClick={() => onEdit(room)}>✎ Edit room</button>
          </div>
        </footer>
      </div>
    </div>
  );
}

/* ---------- DELETE CONFIRM ---------- */

function ConfirmDelete({ room, busy, onCancel, onConfirm }) {
  useModalBehaviour(onCancel, busy);
  return (
    <div className="vr-overlay" onMouseDown={(e) => e.target === e.currentTarget && !busy && onCancel()}>
      <section className="vr-confirm" role="alertdialog" aria-modal="true" aria-labelledby="vr-del-title">
        <div className="vr-confirm-icon">!</div>
        <h2 id="vr-del-title">Delete this room?</h2>
        <p>
          <strong>{room.roomName}</strong> and all its photos will be permanently removed.
          This action cannot be undone.
        </p>
        <div className="vr-confirm-actions">
          <button className="vr-btn secondary" onClick={onCancel} disabled={busy}>Cancel</button>
          <button className="vr-btn danger-solid" onClick={onConfirm} disabled={busy}>
            {busy ? "Deleting..." : "Delete room"}
          </button>
        </div>
      </section>
    </div>
  );
}

/* ---------- MAIN PAGE ---------- */

export default function VillaRoomManager({ villaId: villaIdProp }) {
  const [villas, setVillas] = useState([]);
  const [villasLoading, setVillasLoading] = useState(!villaIdProp);
  const [villaId, setVillaId] = useState(() => {
    if (villaIdProp) return villaIdProp;
    try { return sessionStorage.getItem(VILLA_KEY) || ""; } catch { return ""; }
  });

  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [busyId, setBusyId] = useState(null);

  const [formModal, setFormModal] = useState(null); // { mode, room }
  const [viewRoom, setViewRoom] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleting, setDeleting] = useState(false);

  // load villas for the selector
  useEffect(() => {
    if (villaIdProp) return;
    let cancelled = false;
    (async () => {
      try {
        const data = await apiRequest("/api/vendor/villas/my-villas");
        if (cancelled) return;
        const list = data.villas || data.data || [];
        setVillas(list);
        setVillaId((current) =>
          current && list.some((v) => v._id === current) ? current : list[0]?._id || ""
        );
      } catch (err) {
        if (!cancelled) setError(err.message);
      } finally {
        if (!cancelled) setVillasLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [villaIdProp]);

  useEffect(() => {
    if (!villaId) return;
    try { sessionStorage.setItem(VILLA_KEY, villaId); } catch {}
  }, [villaId]);

  const roomPath = useCallback(
    (suffix = "") => `/api/vendor/villas/${encodeURIComponent(villaId)}/rooms${suffix}`,
    [villaId]
  );

  const loadRooms = useCallback(
    async (silent = false) => {
      if (!villaId) return;
      if (!silent) setLoading(true);
      try {
        const data = await apiRequest(roomPath());
        setRooms(Array.isArray(data.rooms) ? data.rooms : []);
      } catch (err) {
        setError(err.message || "Unable to load rooms.");
      } finally {
        setLoading(false);
      }
    },
    [roomPath, villaId]
  );

  useEffect(() => {
    setRooms([]);
    if (villaId) loadRooms();
  }, [villaId, loadRooms]);

  const villaName = villas.find((v) => v._id === villaId)?.name || "";

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    return rooms.filter((room) => {
      const matchSearch =
        !q ||
        [room.roomName, room.roomNumber, typeLabel(room.roomType)]
          .filter(Boolean)
          .some((v) => String(v).toLowerCase().includes(q));
      const matchStatus =
        statusFilter === "all" ||
        (statusFilter === "active" && room.isActive) ||
        (statusFilter === "inactive" && !room.isActive);
      return matchSearch && matchStatus;
    });
  }, [rooms, search, statusFilter]);

  const stats = {
    types: rooms.length,
    active: rooms.filter((r) => r.isActive).length,
    units: rooms.reduce((s, r) => s + Number(r.totalRooms || 0), 0),
    available: rooms.reduce((s, r) => s + Number(r.availableRooms || 0), 0),
  };

  const handleSaved = (saved, mode) => {
    if (saved?._id) {
      setRooms((prev) =>
        mode === "edit" ? prev.map((r) => (r._id === saved._id ? saved : r)) : [saved, ...prev]
      );
    }
    setFormModal(null);
    setError("");
    setNotice(mode === "edit" ? "Room updated successfully." : "Room added successfully.");
    loadRooms(true);
  };

  const toggleStatus = async (room) => {
    setBusyId(room._id);
    setError("");
    setNotice("");
    try {
      const data = await apiRequest(roomPath(`/${room._id}/toggle-status`), { method: "PATCH" });
      setRooms((prev) =>
        prev.map((r) => (r._id === room._id ? data.room || { ...r, isActive: !r.isActive } : r))
      );
      setNotice(`Room ${room.isActive ? "deactivated" : "activated"}.`);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusyId(null);
    }
  };

  const confirmDelete = async () => {
    if (!deleteTarget) return;
    setDeleting(true);
    setError("");
    try {
      await apiRequest(roomPath(`/${deleteTarget._id}`), { method: "DELETE" });
      setRooms((prev) => prev.filter((r) => r._id !== deleteTarget._id));
      setNotice("Room deleted successfully.");
    } catch (err) {
      setError(err.message);
    } finally {
      setDeleting(false);
      setDeleteTarget(null);
    }
  };

  const openView = async (room) => {
    setViewRoom(room); // show instantly
    try {
      const data = await apiRequest(roomPath(`/${room._id}`));
      if (data.room) setViewRoom(data.room);
    } catch {
      /* keep the list copy */
    }
  };

  const startEdit = (room) => {
    setViewRoom(null);
    setNotice("");
    setFormModal({ mode: "edit", room });
  };

  /* ----- guards ----- */

  if (villasLoading) {
    return (
      <div className="vr-page">
        <div className="vr-center"><span className="vr-spinner" /> Loading your villas...</div>
      </div>
    );
  }

  if (!villaId) {
    return (
      <div className="vr-page">
        {error && <div className="vr-alert error"><span>{error}</span><button onClick={() => setError("")}>×</button></div>}
        <div className="vr-empty">
          <div className="vr-empty-icon">⌂</div>
          <h3>Add a villa first</h3>
          <p>Rooms belong to a villa. Create a villa from “Manage Villas”, then come back here to add its rooms.</p>
        </div>
      </div>
    );
  }

  if (formModal) {
    return (
      <div className="vr-page">
        <RoomFormModal
          key={`${formModal.mode}-${formModal.room?._id || "new"}`}
          mode={formModal.mode}
          room={formModal.room}
          roomPath={roomPath}
          onClose={() => setFormModal(null)}
          onSaved={handleSaved}
        />
      </div>
    );
  }

  if (viewRoom) {
    return (
      <div className="vr-page">
        <RoomViewModal
          key={viewRoom._id}
          room={viewRoom}
          villaName={villaName}
          onClose={() => setViewRoom(null)}
          onEdit={startEdit}
        />
      </div>
    );
  }

  return (
    <div className="vr-page">
      <header className="vr-header">
        <div>
          <div className="vr-kicker">PROPERTY MANAGEMENT / VILLAS</div>
          <h1>Villa rooms</h1>
          <p>Manage room types, photos, pricing and availability.</p>
        </div>
        <div className="vr-header-actions">
          <button className="vr-btn secondary" onClick={() => loadRooms()} disabled={loading}>↻ Refresh</button>
          <button className="vr-btn primary" onClick={() => { setNotice(""); setFormModal({ mode: "create", room: null }); }}>
            ＋ Add room
          </button>
        </div>
      </header>

      {!villaIdProp && villas.length > 0 && (
        <div className="vr-villa-picker">
          <label htmlFor="vr-villa">Villa</label>
          <select id="vr-villa" value={villaId} onChange={(e) => setVillaId(e.target.value)}>
            {villas.map((v) => <option key={v._id} value={v._id}>{v.name}</option>)}
          </select>
        </div>
      )}

      {notice && (
        <div className="vr-alert success"><span>✓ {notice}</span><button onClick={() => setNotice("")}>×</button></div>
      )}
      {error && (
        <div className="vr-alert error" role="alert"><span>{error}</span><button onClick={() => setError("")}>×</button></div>
      )}

      <section className="vr-stats">
        <div className="vr-stat"><span className="vr-stat-icon">▦</span><div><small>Room types</small><strong>{stats.types}</strong></div></div>
        <div className="vr-stat"><span className="vr-stat-icon green">✓</span><div><small>Active</small><strong>{stats.active}</strong></div></div>
        <div className="vr-stat"><span className="vr-stat-icon">⌂</span><div><small>Total units</small><strong>{stats.units}</strong></div></div>
        <div className="vr-stat"><span className="vr-stat-icon amber">◷</span><div><small>Available units</small><strong>{stats.available}</strong></div></div>
      </section>

      <section className="vr-panel">
        <div className="vr-toolbar">
          <div>
            <h2>Room inventory</h2>
            <p>{filtered.length} room type(s){villaName ? ` in ${villaName}` : ""}</p>
          </div>
          <div className="vr-filters">
            <div className="vr-search">
              <span>⌕</span>
              <input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search room..." aria-label="Search rooms" />
            </div>
            <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} aria-label="Filter by status">
              <option value="all">All statuses</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
        </div>

        {loading ? (
          <div className="vr-center"><span className="vr-spinner" /> Loading rooms...</div>
        ) : filtered.length === 0 ? (
          <div className="vr-empty">
            <div className="vr-empty-icon">⌂</div>
            <h3>{rooms.length ? "No matching rooms" : "No rooms added yet"}</h3>
            <p>{rooms.length ? "Try changing the search or status filter." : "Add your first room to start managing this villa's inventory."}</p>
            {!rooms.length && (
              <button className="vr-btn primary" onClick={() => setFormModal({ mode: "create", room: null })}>＋ Add your first room</button>
            )}
          </div>
        ) : (
          <div className="vr-table-wrap">
            <table className="vr-table">
              <thead>
                <tr>
                  <th>Room</th><th>Type</th><th>Capacity</th><th>Availability</th>
                  <th>Price / night</th><th>Status</th><th className="right">Actions</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((room) => {
                  const img = room.coverImage || room.images?.[0];
                  const busy = busyId === room._id;
                  return (
                    <tr key={room._id}>
                      <td>
                        <div className="vr-room-cell">
                          <button type="button" className="vr-room-thumb" onClick={() => openView(room)} aria-label={`View ${room.roomName}`}>
                            {img ? <img src={img} alt={room.roomName} loading="lazy" /> : <span>⌂</span>}
                          </button>
                          <div>
                            <strong>{room.roomName}</strong>
                            <small>{room.roomNumber ? `Room ${room.roomNumber}` : `${room.bedCount || 1} × ${cap(room.bedType)} bed`}</small>
                          </div>
                        </div>
                      </td>
                      <td>{typeLabel(room.roomType)}</td>
                      <td>{room.maxGuests || 1} guests</td>
                      <td>
                        <strong>{room.availableRooms ?? 0}</strong>
                        <span className="vr-muted"> / {room.totalRooms || 0}</span>
                      </td>
                      <td className="vr-price">{money(room.pricePerNight)}</td>
                      <td>
                        <span className={`vr-status ${room.isActive ? "active" : "inactive"}`}>
                          {room.isActive ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td>
                        <div className="vr-actions">
                          <button onClick={() => openView(room)} disabled={busy}>View</button>
                          <button onClick={() => startEdit(room)} disabled={busy}>Edit</button>
                          <button onClick={() => toggleStatus(room)} disabled={busy}>
                            {room.isActive ? "Disable" : "Enable"}
                          </button>
                          <button className="danger" onClick={() => setDeleteTarget(room)} disabled={busy}>Delete</button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </section>


      {deleteTarget && (
        <ConfirmDelete
          room={deleteTarget}
          busy={deleting}
          onCancel={() => setDeleteTarget(null)}
          onConfirm={confirmDelete}
        />
      )}
    </div>
  );
}